<template>
  <v-container fluid>
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="2"
        class="pt-1"
      >
        <inventory-class-select-element
          v-model="inventoryClassId"
          :hide-details="true"
          :is-inst="false"
          :is-glass="false"
          :is-vwd-glass="false"
          :is-panels="false"
          :is-state="true"
          :is-parts="false"
          :is-sid="false"
          :is-rail-part="false"
          :is-equipment="false"
          :is-railings="false"
          :is-paint="false"
          :is-patio-door="false"
          :is-euro-door="false"
          :is-medical-aid="false"
          multiple
        />
      </v-col>

      <v-col
        v-if="windowWidth > 1500"
        class="pt-1 pr-0"
        cols="2"
      >
        <v-autocomplete
          v-model="filterJob"
          label="Job"
          :items="jobs"
          hide-details="true"
          :item-text="item => `${item.code} - ${item.name}; ${item.reference}`"
          item-value="id"
          clearable
          :single-select="false"
          :loading="loadingJobs"
        >
          <template #selection="{ item }">
            <v-chip
              v-if="item && (item.sub_class_color || item.sub_class_name)"
              small
              :color="item.sub_class_color"
              text-color="white"
              class="mr-2"
            >
              {{ item.sub_class_name }}
            </v-chip>
            <span><span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span></span>
          </template>
          <template #item="{ item }">
            <v-chip
              v-if="item && (item.sub_class_color || item.sub_class_name)"
              small
              :color="item.sub_class_color"
              text-color="white"
              class="mr-2"
            >
              {{ item.sub_class_name }}
            </v-chip>
            <span><span style="font-weight: bold;">{{ item.code ? `${item.code}` : '' }}</span> - {{ item.name ? item.name : '' }} <span style="color: #1976D2;">{{ item.reference ? `; ${item.reference}` : '' }}</span></span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-spacer />
      <v-col
        cols="auto"
        class="pl-10"
      >
        <div class="d-flex align-center ga-3">
          <div class="d-flex flex-column align-center justify-center ga-1">
            <span
              style="font-size: 16px !important"
              class="fw600"
            >PRODUCTION ACCURACY</span>
            <div class="d-flex align-center ga-3">
              <v-tooltip top>
                <template #activator="{ on }">
                  <div
                    class="pt-2 pb-2 pl-4 pr-4 d-flex"
                    style="border: 1px solid #BDBDBD; border-radius: 6px; box-shadow: rgba(0,0,0,0.05) 0px 6px 24px 0px, rgba(0,0,0,0.08) 0px 0px 0px 01px;"
                    v-on="on"
                  >
                    <span
                      :style="`font-size: 18px !important; color: ${windowAccuracy && windowAccuracy.yesterday_produced < 64 ? '#D32F2F' : windowAccuracy && windowAccuracy.yesterday_produced > 65 && windowAccuracy.yesterday_produced < 89 ? '#FBC02D' : '#388E3C'}`"
                      class="fw600 pr-2"
                    >{{ windowAccuracy ? windowAccuracy.yesterday_produced : '' }}%</span>
                    <span
                      style="font-size: 18px !important"
                      class="fw500"
                    >Yesterday</span>
                  </div>
                </template>
                <span>Production Window Accuracy – Percentage of finished goods produced ahead of the production completion date — for yesterday only.</span>
              </v-tooltip>
              <v-tooltip top>
                <template #activator="{ on }">
                  <div
                    class="pt-2 pb-2 pl-4 pr-4 d-flex"
                    style="border: 1px solid #BDBDBD; border-radius: 6px; box-shadow: rgba(0,0,0,0.05) 0px 6px 24px 0px, rgba(0,0,0,0.08) 0px 0px 0px 01px;"
                    v-on="on"
                  >
                    <span
                      :style="`font-size: 18px !important; color: ${windowAccuracy && windowAccuracy.weekly_produced < 64 ? '#D32F2F' : windowAccuracy && windowAccuracy.weekly_produced > 65 && windowAccuracy.weekly_produced < 89 ? '#FBC02D' : '#388E3C'}`"
                      class="fw600 pr-2"
                    >{{ windowAccuracy ? windowAccuracy.weekly_produced : '' }}%</span>
                    <span
                      style="font-size: 18px !important"
                      class="fw500"
                    >Weekly</span>
                  </div>
                </template>
                <span>Production Window Accuracy – Weekly average percentage of finished goods produced before the production completion date for this week</span>
              </v-tooltip>
              <v-tooltip top>
                <template #activator="{ on }">
                  <div
                    class="pt-2 pb-2 pl-4 pr-4 d-flex"
                    style="border: 1px solid #BDBDBD; border-radius: 6px; box-shadow: rgba(0,0,0,0.05) 0px 6px 24px 0px, rgba(0,0,0,0.08) 0px 0px 0px 01px;"
                    v-on="on"
                  >
                    <span
                      :style="`font-size: 18px !important; color: ${windowAccuracy && windowAccuracy.monthly_produced < 64 ? '#D32F2F' : windowAccuracy && windowAccuracy.monthly_produced > 65 && windowAccuracy.monthly_produced < 89 ? '#FBC02D' : '#388E3C'}`"
                      class="fw600 pr-2"
                    >{{ windowAccuracy ? windowAccuracy.monthly_produced : '' }}%</span>
                    <span
                      style="font-size: 18px !important"
                      class="fw500"
                    >Monthly</span>
                  </div>
                </template>
                <span>Production Window Accuracy – Monthly average percentage of finished goods produced before the production completion date for this month</span>
              </v-tooltip>
            </div>
          </div>
          <div class="d-flex flex-column align-center justify-center ga-1">
            <span
              style="font-size: 16px !important"
              class="fw600"
            >SHIPPING ACCURACY</span>
            <div class="d-flex align-center ga-3">
              <v-tooltip top>
                <template #activator="{ on }">
                  <div
                    class="pt-2 pb-2 pl-4 pr-4 d-flex"
                    style="border: 1px solid #BDBDBD; border-radius: 6px; box-shadow: rgba(0,0,0,0.05) 0px 6px 24px 0px, rgba(0,0,0,0.08) 0px 0px 0px 01px;"
                    v-on="on"
                  >
                    <span
                      :style="`font-size: 18px !important; color: ${windowAccuracy && windowAccuracy.yesterday < 64 ? '#D32F2F' : windowAccuracy && windowAccuracy.yesterday > 65 && windowAccuracy.yesterday < 89 ? '#FBC02D' : '#388E3C'}`"
                      class="fw600 pr-2"
                    >{{ windowAccuracy ? windowAccuracy.yesterday : '' }}%</span>
                    <span
                      style="font-size: 18px !important"
                      class="fw500"
                    >Yesterday</span>
                  </div>
                </template>
                <span>Production Window Accuracy – Percentage of finished goods shipped ahead of the planned ship date — for yesterday only.</span>
              </v-tooltip>
              <v-tooltip top>
                <template #activator="{ on }">
                  <div
                    class="pt-2 pb-2 pl-4 pr-4 d-flex"
                    style="border: 1px solid #BDBDBD; border-radius: 6px; box-shadow: rgba(0,0,0,0.05) 0px 6px 24px 0px, rgba(0,0,0,0.08) 0px 0px 0px 01px;"
                    v-on="on"
                  >
                    <span
                      :style="`font-size: 18px !important; color: ${windowAccuracy && windowAccuracy.weekly < 64 ? '#D32F2F' : windowAccuracy && windowAccuracy.weekly > 65 && windowAccuracy.weekly < 89 ? '#FBC02D' : '#388E3C'}`"
                      class="fw600 pr-2"
                    >{{ windowAccuracy ? windowAccuracy.weekly : '' }}%</span>
                    <span
                      style="font-size: 18px !important"
                      class="fw500"
                    >Weekly</span>
                  </div>
                </template>
                <span>Shipping Window Accuracy – Weekly average percentage of finished goods shipped before the planned ship date for this week</span>
              </v-tooltip>
              <v-tooltip top>
                <template #activator="{ on }">
                  <div
                    class="pt-2 pb-2 pl-4 pr-4 d-flex"
                    style="border: 1px solid #BDBDBD; border-radius: 6px; box-shadow: rgba(0,0,0,0.05) 0px 6px 24px 0px, rgba(0,0,0,0.08) 0px 0px 0px 01px;"
                    v-on="on"
                  >
                    <span
                      :style="`font-size: 18px !important; color: ${windowAccuracy && windowAccuracy.monthly < 64 ? '#D32F2F' : windowAccuracy && windowAccuracy.monthly > 65 && windowAccuracy.monthly < 89 ? '#FBC02D' : '#388E3C'}`"
                      class="fw600 pr-2"
                    >{{ windowAccuracy ? windowAccuracy.monthly : '' }}%</span>
                    <span
                      style="font-size: 18px !important"
                      class="fw500"
                    >Monthly</span>
                  </div>
                </template>
                <span>Shipping Window Accuracy – Monthly average percentage of finished goods shipped before the planned ship date for this month</span>
              </v-tooltip>
            </div>
          </div>
        </div>
      </v-col>
      <v-spacer />
    </v-row>

    <v-row align="center">
      <v-col
        v-for="tab, idx in tabs"
        :key="idx"
        cols="auto"
        :style="`cursor: pointer; border-bottom: ${JSON.stringify(selectedTab) == JSON.stringify(tab) ? '2px solid #1976d2' : 'none'};`"
        class="ml-2 mr-2"
        @click="tabChange(tab)"
      >
        <span :style="`font-size: 16px !important; color: ${JSON.stringify(selectedTab) == JSON.stringify(tab) ? '#1976d2' : isDarkMode ? '' : 'rgba(0,0,0,0.8)'}; font-weight: ${JSON.stringify(selectedTab) == JSON.stringify(tab) ? 'bold' : 'normal'};`">{{ tab.name }}</span>
      </v-col>
      <v-spacer />
      <v-col
        cols="auto"
        class="pb-0 pl-0 pt-1"
      >
        <v-menu
          v-model="filterMenu"
          transition="scale-transition"
          offset-y
          min-width="500"
          nudge-left="50"
          :close-on-content-click="false"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              color="success"
              outlined
              v-bind="attrs"
              v-on="on"
              @click="filterMenu = !filterMenu"
            >
              <v-icon
                small
                class="mr-1"
              >
                mdi-filter
              </v-icon>
              FILTERS
            </v-btn>
          </template>
          <v-card
            class="pa-8"
          >
            <v-row>
              <v-col>
                <v-row>
                  <v-col>
                    <span style="font-size: 22px !important; font-weight: bold;">Filters</span>
                  </v-col>
                  <v-col class="text-end pr-1">
                    <v-btn
                      icon
                      :style="{color: isDarkMode ? '' : '#000000'}"
                      @click="filterMenu = !filterMenu"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-select
                      v-model="filterRecordType"
                      label="Records Type"
                      :items="recordTypes"
                      hide-details="true"
                      item-text="name"
                      item-value="id"
                      clearable
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-select
                      v-model="filterStage"
                      label="Production Stage"
                      :items="stages"
                      hide-details="true"
                      item-text="name"
                      item-value="id"
                      clearable
                    >
                      <template #selection="{ item }">
                        <v-row align="center">
                          <v-col
                            cols="auto"
                            class="pr-0"
                          >
                            <v-btn
                              elevation="0"
                              fab
                              outlined
                              tile
                              readonly
                              color="#FFD84D"
                              style="border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid #FFD84D;"
                            >
                              <span
                                style="color: #000000;"
                              >{{ item.code }}</span>
                            </v-btn>
                          </v-col>
                          <v-col>
                            <span style="font-size: 14px !important;">{{ item.name }}</span>
                          </v-col>
                        </v-row>
                      </template>
                      <template #item="{ item }">
                        <v-row align="center">
                          <v-col
                            cols="auto"
                            class="pr-0"
                          >
                            <v-btn
                              elevation="0"
                              fab
                              outlined
                              tile
                              readonly
                              color="#FFD84D"
                              style="border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid #FFD84D;"
                            >
                              <span
                                style="color: #000000;"
                              >
                                {{ item.code }}</span>
                            </v-btn>
                          </v-col>
                          <v-col>
                            <span style="font-size: 14px !important;">{{ item.name }}</span>
                          </v-col>
                        </v-row>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-autocomplete
                      v-model="filterPo"
                      label="SP+S/U PO#"
                      :items="poNumbers"
                      hide-details
                      clearable
                      :loading="loadingPo"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menuRequiredBy"
                      v-model="dateMenuRequiredBy"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterGlassReqBy"
                          label="Glass Required By"
                          readonly
                          v-bind="attrs"
                          append-icon="mdi-calendar"
                          hide-details
                          v-on="on"
                          @change="$refs.menuRequiredBy.save(filterGlassReqBy)"
                        />
                      </template>
                      <business-date-picker
                        v-model="filterGlassReqBy"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterGlassReqBy = null"
                        >
                          Clear
                        </v-btn>
                      </business-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menuShipDate"
                      v-model="dateMenuShipDate"
                      transition="scale-transition"
                      offset-y
                      clearable
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterPlannedShipDate"
                          readonly
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                          @change="$refs.menuShipDate.save(filterPlannedShipDate)"
                        >
                          <template slot="label">
                            Plan Ship Date From
                          </template>
                        </v-text-field>
                      </template>
                      <business-date-picker
                        v-model="filterPlannedShipDate"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterPlannedShipDate = null"
                        >
                          Clear
                        </v-btn>
                      </business-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menuShipDateEnd"
                      v-model="dateMenuShipDateEnd"
                      transition="scale-transition"
                      offset-y
                      clearable
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterPlannedShipDateEnd"
                          readonly
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                          @change="$refs.menuShipDateEnd.save(filterPlannedShipDateEnd)"
                        >
                          <template slot="label">
                            Plan Ship Date To
                          </template>
                        </v-text-field>
                      </template>
                      <business-date-picker
                        v-model="filterPlannedShipDateEnd"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterPlannedShipDateEnd = null"
                        >
                          Clear
                        </v-btn>
                      </business-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menuProductionCompletionDate"
                      v-model="dateMenuProductionCompletionDate"
                      transition="scale-transition"
                      offset-y
                      clearable
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterProductionCompletionDate"
                          readonly
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                          @change="$refs.menuProductionCompletionDate.save(filterProductionCompletionDate)"
                        >
                          <template slot="label">
                            Production Completion Date From
                          </template>
                        </v-text-field>
                      </template>
                      <business-date-picker
                        v-model="filterProductionCompletionDate"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterProductionCompletionDate = null"
                        >
                          Clear
                        </v-btn>
                      </business-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menuProductionCompletionDateEnd"
                      v-model="dateMenuProductionCompletionDateEnd"
                      transition="scale-transition"
                      offset-y
                      clearable
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterProductionCompletionDateEnd"
                          readonly
                          append-icon="mdi-calendar"
                          v-bind="attrs"
                          hide-details
                          v-on="on"
                          @change="$refs.menuProductionCompletionDateEnd.save(filterProductionCompletionDateEnd)"
                        >
                          <template slot="label">
                            Production Completion Date To
                          </template>
                        </v-text-field>
                      </template>
                      <business-date-picker
                        v-model="filterProductionCompletionDateEnd"
                        no-title
                        scrollable
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="filterProductionCompletionDateEnd = null"
                        >
                          Clear
                        </v-btn>
                      </business-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col
                    class="pt-8"
                    cols="auto"
                  >
                    <span :style="{color: isDarkMode ? '#ffffffb3' : '#00000099', fontSize: '16px !important'}">Hide</span>
                  </v-col>
                  <v-col
                    class="pl-0"
                  >
                    <v-switch
                      v-model="isGlassRelated"
                      hide-details
                      label="Show Glass Related Only"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col />
                </v-row>
                <v-row>
                  <v-spacer />
                  <v-col
                    cols="auto"
                    class="pr-0"
                  >
                    <v-btn
                      color="normal"
                      @click="filterMenu = !filterMenu"
                    >
                      <span style="font-size: 14px !important;">Close</span>
                    </v-btn>
                  </v-col>
                  <v-col cols="auto">
                    <v-btn
                      color="primary"
                      @click="clearAllFilters"
                    >
                      Clear
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-menu>
      </v-col>
      <v-col
        cols="auto"
        class="pb-0 pl-0 pt-1"
      >
        <v-menu
          offset-y
          min-width="400"
          :close-on-content-click="false"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              color="orange"
              outlined
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                style="font-size: 20px;"
                class="pr-1"
              >
                mdi-cog
              </v-icon> MORE OPTIONS
            </v-btn>
          </template>
          <v-card>
            <div class="d-flex flex-column ga-4 pa-6">
              <div
                class="options-item-div"
                @click="openReturnedWindows()"
              >
                <v-icon style="color: #2563EB;">
                  mdi-window-restore
                </v-icon>
                <span style="color: #2563EB; font-weight: 600; font-size: 16px !important">RETURNED WINDOWS</span>
              </div>
              <div
                class="options-item-div"
                @click="openFinishedGoods()"
              >
                <v-icon style="color: #9333EA;">
                  mdi-window-maximize
                </v-icon>
                <span style="color: #9333EA; font-weight: 600; font-size: 16px !important">FINISHED GOODS</span>
              </div>
              <div
                class="options-item-div"
                @click="openQuarantinedWindows()"
              >
                <v-icon style="color: #FB8C00;">
                  mdi-alert-box-outline
                </v-icon>
                <span style="color: #FB8C00; font-weight: 600; font-size: 16px !important">QUARANTINED WINDOWS</span>
              </div>
              <div
                v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin))"
                :disabled="!selectedItems || selectedItems.length === 0"

                class="options-item-div"
                @click="archiveAll()"
              >
                <v-icon style="color: #0D9488;">
                  mdi-archive-outline
                </v-icon>
                <span style="color: #0D9488; font-weight: 600; font-size: 16px !important">{{ status == 1 ? 'ARCHIVE' : 'RESTORE' }}</span>
              </div>
              <div style="border-bottom: 1px solid rgba(0,0,0,0.2);" />
              <div
                class="options-item-div"
                @click="runWebhook('pdf')"
              >
                <v-icon style="color: #DC2626;">
                  mdi-file-document-outline
                </v-icon>
                <span style="color: #DC2626; font-weight: 600; font-size: 16px !important">GENERATE PDF</span>
              </div>
              <div
                class="options-item-div"
                @click="runWebhook('xls')"
              >
                <v-icon style="color: #16A34A;">
                  mdi-file-excel-outline
                </v-icon>
                <span style="color: #16A34A; font-weight: 600; font-size: 16px !important">GENERATE XLS</span>
              </div>
              <!-- <div
                v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate)"
                class="options-item-div"
                @click="sendEmailPdf()"
              >
                <v-icon style="color: #D97706;">
                  mdi-email-outline
                </v-icon>
                <span style="color: #D97706; font-weight: 600; font-size: 16px !important">SEND EMAIL PDF</span>
              </div> -->
              <div style="border-bottom: 1px solid rgba(0,0,0,0.2);" />
              <div
                :disabled="selectedItems.length === 0"
                class="options-item-div"
                @click="openGlassRequiredByDateFormMultiple()"
              >
                <v-icon :style="`color: ${selectedItems.length === 0 ? 'rgba(0,0,0,0.4)' : '#DB2777'};`">
                  mdi-calendar-blank-outline
                </v-icon>
                <span :style="`color: ${selectedItems.length === 0 ? 'rgba(0,0,0,0.4)' : '#DB2777'}; font-weight: 600; font-size: 16px !important`">CHANGE GLASS REQUIRED BY DATE</span>
              </div>
              <div
                :disabled="selectedItems.length === 0"
                class="options-item-div"
                @click="openPlannedShipDateMultipleForm()"
              >
                <v-icon :style="`color: ${selectedItems.length === 0 ? 'rgba(0,0,0,0.4)' : '#0891B2'};`">
                  mdi-truck-delivery-outline
                </v-icon>
                <span :style="`color: ${selectedItems.length === 0 ? 'rgba(0,0,0,0.4)' : '#0891B2'}; font-weight: 600; font-size: 16px !important`">CHANGE PLAN SHIP DATE</span>
              </div>
              <div style="border-bottom: 1px solid rgba(0,0,0,0.2);" />
              <div
                style="width: 100%;"
                class="d-flex flex-column ga-4"
              >
                <div
                  class="d-flex align-center justify-space-between"
                >
                  <div class="options-item-div">
                    <div class="d-flex flex-column ">
                      <span style="font-size: 16px !important; color: #000; font-weight: 500;">View Mode - {{ !isShowBreakdown ? 'Main' : 'Breakdown' }} View</span>
                      <span style="font-size: 14px !important;">Toggle between Main and Breakdown views </span>
                    </div>
                  </div>

                  <v-switch
                    v-model="isShowBreakdown"
                    hide-details
                    class="mt-0"
                  />
                </div>
                <div
                  class="d-flex align-center justify-space-between"
                >
                  <div class="options-item-div">
                    <div class="d-flex flex-column ">
                      <span style="font-size: 16px !important; color: #000; font-weight: 500;">View Mode - {{ isShowStages ? 'Show' : 'Hide' }} Stages</span>
                      <span style="font-size: 14px !important;">Toggle between Show and Hide stages </span>
                    </div>
                  </div>
                  <v-switch
                    v-model="isShowStages"
                    hide-details
                    class="mt-0"
                    @click.stop
                  />
                </div>
              </div>
            </div>
          </v-card>
        </v-menu>
      </v-col>
      <v-col
        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin))"
        cols="auto"
        class="pb-0 pl-0 pt-1"
      >
        <v-btn
          color="primary"
          outlined
          @click="open()"
        >
          <v-icon
            small
            class="mr-1"
          >
            fas fa-plus
          </v-icon>
          New Record
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="!isShowBreakdown">
      <v-col
        class="pa-1"
      >
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="footer"
            :items-per-page="pagination.itemsPerPage"
            :search="search"
            fixed-header
            :loading="loading"
            dense
            :height="windowHeight"
            :server-items-length="totalItems"
            @update:options="updateOptions"
          >
            <template
              v-for="h in headers"
              #[`header.${h.value}`]="{ header }"
            >
              <v-tooltip
                :key="h.value"
                top
              >
                <template #activator="{ on }">
                  <span v-on="on">{{ header.text }}</span>
                </template>
                <span>{{ header.fullText }}</span>
              </v-tooltip>
            </template>
            <template #item="{ item }">
              <tr>
                <td
                  v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate))"
                  class="pl-1 pr-1"
                >
                  <v-checkbox
                    v-model="selectedItems"
                    :disabled="status == statusIdOnHand && selectedItems.length >= 1 && !selectedItems.includes(item)"
                    :value="item"
                    class="mt-0 mb-0 pt-0"
                    hide-details
                  />
                </td>
                <td class="pl-1 pr-1">
                  <v-chip
                    small
                    :color="item && item.class ? item.class.color : 'grey'"
                    text-color="white"
                  >
                    {{ item && item.class ? item.class.name : '' }}
                  </v-chip>
                </td>
                <td class="pl-1 pr-1">
                  <span><text-highlight :queries="search">{{ item.location ? formatLocation(item.location.name) : '' }}</text-highlight></span>
                </td>
                <td class="pl-1 pr-1">
                  <v-tooltip
                    top
                    color="transparent"
                    style="opacity: 1;"
                  >
                    <template #activator="{ on }">
                      <span
                        v-if="item.is_shipping && item.total_shipping == 0 && item.is_glaze == 1"
                        :style="{fontWeight: 500, color: (isDarkMode ? 'black' : '#000000'), borderRadius: '4px', width: 'auto', height: '25px', border: 0, backgroundColor: '#C8E6C9'}"
                        class="pa-1"
                        v-on="on"
                      ><text-highlight :queries="search">{{ item.project }}</text-highlight></span>
                      <span
                        v-else-if="item.is_ready_for_shipping == 1"
                        :style="{fontWeight: 500, color: (isDarkMode ? 'black' : '#000000'), borderRadius: '4px', width: 'auto', height: '25px', border: 0, backgroundColor: '#F8BBD0'}"
                        class="pa-1"
                        v-on="on"
                      ><text-highlight :queries="search">{{ item.project }}</text-highlight></span>

                      <span
                        v-else
                        style="font-weight: 500;"
                        v-on="on"
                      ><text-highlight :queries="search">{{ item.project }}</text-highlight></span>
                    </template>
                    <v-chip
                      v-if="item && (item.sub_class_color || item.sub_class_name)"
                      small
                      :color="item.sub_class_color"
                      text-color="white"
                    >
                      {{ item.sub_class_name }}
                    </v-chip>
                  </v-tooltip>
                </td>
                <td class="pl-1 pr-1">
                  <span><text-highlight :queries="search">{{ item.project_floor }}</text-highlight></span>
                </td>
                <td class="pl-1 pr-1">
                  <v-tooltip
                    color="black"
                    top
                  >
                    <template #activator="{ on }">
                      <span v-on="on"><text-highlight
                        :queries="search"
                        v-on="on"
                      >{{ item.wo_number }}</text-highlight></span>
                    </template>
                    <span>{{ item.created_at_po_min }}</span>
                  </v-tooltip>
                </td>
                <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <span><text-highlight :queries="search">{{ item.window_verticals }}</text-highlight></span>
                </td>
                <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <span><text-highlight :queries="search">{{ item.patio_doors }}</text-highlight></span>
                </td>
                <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <span><text-highlight :queries="search">{{ item.euro_doors }}</text-highlight></span>
                </td>
                <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <span>{{ item.total_release_qty }}</span>
                </td>
                <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    elevation="0"
                    fab
                    outlined
                    tile
                    color="#FFD84D"
                    :class="`box ${item.is_pp_finished ? 'green-box' : item.is_pp_started ? 'yellow-box' : 'empty-box'}`"
                    @click="triggerStageChange(item, ppStartedId)"
                  >
                    <span
                      v-if="item.is_pp_finished"
                      :style="`color: #FFFFFF`"
                    >{{ item.total_project_panels ? item.total_project_panels : '0' }}</span>
                    <span
                      v-else-if="item.is_pp_started"
                      :style="`color: #000000`"
                    >{{ item.total_project_panels ? item.total_project_panels : '0' }}</span>
                    <span
                      v-else
                      :style="`color: #000000;`"
                    >{{ item.total_project_panels ? item.total_project_panels : '0' }}</span>
                  </v-btn>
                </td>
                <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    elevation="0"
                    fab
                    outlined
                    tile
                    color="#FFD84D"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid #FFD84D; background-color: ${item.is_splander_paint ? '#FFD84D' : ''}`"
                    @click="triggerStageChange(item, spandrelId)"
                  >
                    <span
                      v-if="item.is_splander_paint"
                      style="color: #000000;"
                    >S</span>
                  </v-btn>
                </td>
                <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    elevation="0"
                    fab
                    outlined
                    tile
                    color="#FFD84D"
                    :class="`box ${item.is_panels && (item.total_back_panels > 0) ? 'green-box' : item.total_back_panels ? 'yellow-box' : 'empty-box'}`"
                    :disabled="item.total_back_panels == null || item.total_back_panels <= 0"
                    @click="triggerStageChange(item, panelsId)"
                  >
                    <span
                      v-if="item.total_back_panels > 0"
                      :style="`color: ${item.is_panels && (item.total_back_panels > 0) ? '#FFFFFF' : '#000000'}`"
                    >{{ item.total_back_panels }}</span>
                  </v-btn>
                </td>
                <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    :ripple="false"
                    color="#FFD84D"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid #FFD84D; background-color: ${item.is_material_available ? '#FFD84D' : ''}`"
                    @click="triggerStageChange(item, materialAvailableId)"
                  >
                    <span
                      v-if="item.is_material_available"
                      style="color: #000000;"
                    >M</span>
                  </v-btn>
                </td>
                <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    :ripple="false"
                    color="#FFD84D"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_cut > 0 ? '#FFD84D' : item.is_assemble == 1 ? '#4CAF50' : ''}; background-color: ${item.total_cut > 0 ? '#FFD84D' : item.is_assemble == 1 ? '#4CAF50' : ''}`"
                    @click="openFinishedGoodForm(item, 2)"
                  >
                    <span
                      v-if="item.total_cut > 0"
                      style="color: #000000;"
                    >{{ item.total_cut }}</span>
                    <span
                      v-else-if="item.is_assemble == 1"
                      style="color: #FFFFFF;"
                    >C</span>
                    <span
                      v-else
                      style="color: #000000;"
                    />
                  </v-btn>
                </td>
                <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    color="#FFD84D"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_assemble > 0 ? '#FFD84D' : item.is_t_and_b == 1 ? '#4CAF50' : ''}; background-color: ${item.total_assemble > 0 ? '#FFD84D' : item.is_t_and_b == 1 ? '#4CAF50' : ''}`"
                    @click="openFinishedGoodForm(item, 4)"
                  >
                    <span
                      v-if="item.total_assemble > 0"
                      style="color: #000000;"
                    >{{ item.total_assemble }}</span>
                    <span
                      v-else-if="item.is_t_and_b == 1"
                      style="color: #FFFFFF;"
                    >A</span>
                    <span
                      v-else
                      style="color: #000000;"
                    />
                  </v-btn>
                </td>
                <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    color="#FFD84D"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_t_and_b > 0 ? '#FFD84D' : item.is_glaze == 1 ? '#4CAF50' : ''}; background-color: ${item.total_t_and_b > 0 ? '#FFD84D' : item.is_glaze == 1 ? '#4CAF50' : ''}`"
                    @click="openFinishedGoodForm(item, 5)"
                  >
                    <span
                      v-if="item.total_t_and_b > 0"
                      style="color: #000000;"
                    >{{ item.total_t_and_b }}</span>
                    <span
                      v-else-if="item.is_glaze == 1"
                      style="color: #FFFFFF;"
                    >T</span>
                    <span
                      v-else
                      style="color: #000000;"
                    />
                  </v-btn>
                </td>
                <td
                  v-if="isShowStages"
                  class="pl-1 pr-1"
                >
                  <v-btn
                    elevation="0"
                    fab
                    outlined
                    tile
                    color="#FFD84D"
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_glaze > 0 ? '#FFD84D' : item.is_glaze == 1 ? '#4CAF50' : ''}; background-color: ${item.total_glaze > 0 ? '#FFD84D' : item.is_glaze == 1 ? '#4CAF50' : ''}`"
                    @click="openFinishedGoodForm(item, 6)"
                  >
                    <span
                      v-if="item.total_glaze > 0"
                      style="color: #000000;"
                    >{{ item.total_glaze }}</span>
                    <span
                      v-else-if="item.is_glaze == 1"
                      style="color: #FFFFFF;"
                    >G</span>
                    <span
                      v-else
                      style="color: #000000;"
                    />
                  </v-btn>
                </td>
                <td class="pl-1 pr-1 text-center">
                  <v-btn
                    v-if="item.is_prod_backlog && item.total_prod_backlog >= 0"
                    elevation="0"
                    fab
                    outlined
                    tile
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_prod_backlog != 0 ? '#EF5350' : '#4CAF50'}; background-color: ${item.total_prod_backlog != 0 ? '#EF5350' : '#4CAF50'} ;`"
                    @click="openFinishedGoodForm(item, 8)"
                  >
                    <span
                      style="color: #FFFFFF;"
                    >{{ item.total_prod_backlog || item.total_prod_backlog == 0 ? item.total_prod_backlog : '' }}</span>
                  </v-btn>
                  <a
                    v-else
                  >-</a>
                </td>
                <td class="pl-1 pr-1">
                  <v-btn
                    v-if="item.is_shipping && item.total_shipping >= 0"
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_shipping != 0 ? '#EF5350' : '#4CAF50'}; background-color: ${item.total_shipping != 0 ? '#EF5350' : '#4CAF50'};`"
                    @click="openFinishedGoodForm(item, 9)"
                  >
                    <span
                      style="color: #FFFFFF;"
                    >{{ item.total_shipping || item.total_shipping == 0 ? item.total_shipping : '' }}</span>
                  </v-btn>
                  <a
                    v-else
                  >-</a>
                </td>
                <td class="pl-1 pr-1">
                  <v-btn
                    v-if="item.is_received && item.total_shipped >= 0"
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_shipped != 0 ? '#EF5350' : '#4CAF50'}; background-color: ${item.total_shipped != 0 ? '#EF5350' : '#4CAF50'};`"
                    @click="openFinishedGoodForm(item, 10)"
                  >
                    <span
                      style="color: #FFFFFF;"
                    >{{ item.total_shipped || item.total_shipped == 0 ? item.total_shipped : '' }}</span>
                  </v-btn>
                  <a
                    v-else
                  >-</a>
                </td>
                <td class="pl-1 pr-1">
                  <v-btn
                    v-if="item.total_returned > 0"
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_returned != 0 ? '#EF5350' : '#4CAF50'}; background-color: ${item.total_returned != 0 ? '#EF5350' : '#4CAF50'};`"
                    @click="openFinishedGoodForm(item, 12)"
                  >
                    <span
                      style="color: #FFFFFF;"
                    >{{ item.total_returned || item.total_returned == 0 ? item.total_returned : '' }}</span>
                  </v-btn>
                  <a
                    v-else
                  >-</a>
                </td>
                <td class="pl-1 pr-1">
                  <v-btn
                    v-if="item.total_quarantined > 0"
                    elevation="0"
                    fab
                    outlined
                    tile
                    readonly
                    :style="`border-radius: 4px; width: 25px; height: 25px; border: 1.5px solid ${item.total_quarantined != 0 ? '#D50000' : '#4CAF50'}; background-color: ${item.total_quarantined != 0 ? '#D50000' : '#4CAF50'};`"
                    @click="openFinishedGoodForm(item, 13)"
                  >
                    <span
                      style="color: #FFFFFF;"
                    >{{ item.total_quarantined || item.total_quarantined == 0 ? item.total_quarantined : '' }}</span>
                  </v-btn>
                  <a
                    v-else
                  >-</a>
                </td>
                <td class="pl-1 pr-1 text-center">
                  <span
                    v-if="item.sp_po_number"
                    style="cursor: pointer;"
                    @click="openWindowBreakdown(item, typeIdSPItems)"
                  ><text-highlight :queries="search">{{ item.sp_po_number }}</text-highlight></span>
                  <span
                    v-else
                  >N/A</span>
                </td>
                <td
                  class="pl-1 pr-1"
                  @click="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdGlassHandler) ? openMenuSPGlassNote(item.id) : ''"
                >
                  <v-btn
                    v-if="item.sp_note_status"
                    elevation="0"
                    fab
                    outlined
                    tile
                    :color="item.sp_note_status.color"
                    :style="{
                      borderRadius: '4px',
                      width: item.sp_note_status.name === 'N/A' || item.sp_note_status.name === 'PEN' || (item.sp_note_status.id === noteStatusIdShort && item.sp_note && item.sp_note.length > 2) ? 'auto' : '25px',
                      height: '25px',
                      padding: '0 7px',
                      border: `1.5px solid ${item.sp_note_status.color}`,
                      backgroundColor: `${item.sp_note_status.color}`,
                    }"
                  >
                    <span
                      v-if="item.sp_note_status.id === noteStatusIdShort"
                      style="color: #000000;"
                    >-{{ item.sp_note }}</span>
                    <span
                      v-else
                      :style="`color: ${item.sp_note_status_id === noteStatusIdZero ? '#FFF' : '#000'}`"
                    >{{ item.sp_note_status.name }}</span>
                  </v-btn>
                  <v-btn
                    v-else
                    elevation="0"
                    fab
                    outlined
                    tile
                    :style="{
                      borderRadius: '4px',
                      width: 'auto',
                      height: '25px',
                      padding: '0 7px',
                      border: `1.5px solid #E0E0E0`,
                      backgroundColor: `#E0E0E0`,
                      color: '#000000'
                    }"
                  >
                    <span>N/A</span>
                  </v-btn>
                </td>
                <td
                  v-if="!isShowStages"
                  class="text-center"
                >
                  <v-chip
                    v-if="item.sp_po_status"
                    small
                    :color="item && item.sp_po_status ? item.sp_po_status.color : 'black'"
                    text-color="white"
                  >
                    {{ item && item.sp_po_status ? item.sp_po_status.name : '' }}
                  </v-chip>
                </td>
                <td class="pl-1 pr-1 text-center">
                  <span
                    v-if="item.su_po_number"
                    style="cursor: pointer;"
                    @click="openWindowBreakdown(item, typeIdSUItems)"
                  ><text-highlight :queries="search">{{ item.su_po_number }}</text-highlight></span>
                  <span
                    v-else
                  >N/A</span>
                </td>
                <td
                  class="pl-1 pr-1"
                  style="cursor: pointer;"
                  @click="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdGlassHandler) ? openMenuSUGlassNote(item.id) : ''"
                >
                  <v-btn
                    v-if="item.su_note_status"
                    elevation="0"
                    fab
                    outlined
                    tile
                    :color="item.su_note_status.color"
                    :style="{
                      borderRadius: '4px',
                      width: item.su_note_status.name === 'N/A' || item.su_note_status.name === 'PEN' || (item.su_note_status.id === noteStatusIdShort && item.su_note && item.su_note.length > 2) ? 'auto' : '25px',
                      height: '25px',
                      padding: '0 7px',
                      border: `1.5px solid ${item.su_note_status.color}`,
                      backgroundColor: `${item.su_note_status.color}`
                    }"
                  >
                    <span
                      v-if="item.su_note_status.id === noteStatusIdShort"
                      :style="`color: #000;`"
                    >-{{ item.su_note }}</span>
                    <span
                      v-else
                      :style="`color: ${item.su_note_status_id === noteStatusIdZero ? '#FFF' : '#000'}`"
                    >{{ item.su_note_status.name }}</span>
                  </v-btn>
                  <v-btn
                    v-else
                    elevation="0"
                    fab
                    outlined
                    tile
                    :style="{
                      borderRadius: '4px',
                      width: 'auto',
                      height: '25px',
                      padding: '0 7px',
                      border: `1.5px solid #E0E0E0`,
                      backgroundColor: `#E0E0E0`,
                      color: '#000000'
                    }"
                  >
                    <span>N/A</span>
                  </v-btn>
                </td>
                <td
                  v-if="!isShowStages"
                  class="text-center"
                >
                  <v-chip
                    v-if="item.su_po_status"
                    small
                    :color="item && item.su_po_status ? item.su_po_status.color : 'black'"
                    text-color="white"
                  >
                    {{ item && item.su_po_status ? item.su_po_status.name : '' }}
                  </v-chip>
                </td>
                <td class="pl-1 pr-1">
                  <a
                    style="white-space: nowrap;"
                    @click="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) ? openGlassRequiredByDateForm(item) : ''"
                  ><text-highlight :queries="search">{{ item.glass_required_by_short }}</text-highlight></a>
                </td>
                <td class="pl-0 pr-0">
                  <v-icon
                    v-if="item.required_by_is_up == 1"
                    color="#388E3C"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-up
                  </v-icon>
                  <v-icon
                    v-else-if="item.required_by_is_up == 0"
                    color="#D32F2F"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-down
                  </v-icon>
                </td>
                <td class="pl-1 pr-1">
                  <a
                    style="white-space: nowrap;"
                    @click="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) ? openProductionCompletionDateForm(item) : ''"
                  ><text-highlight :queries="search">{{ item.production_completion_date_short }}</text-highlight></a>
                </td>
                <td class="pl-0 pr-0">
                  <v-icon
                    v-if="item.production_completion_date_is_up == 1"
                    color="#388E3C"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-up
                  </v-icon>
                  <v-icon
                    v-else-if="item.production_completion_date_is_up == 0"
                    color="#D32F2F"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-down
                  </v-icon>
                </td>
                <td
                  class="pl-1 pr-1"
                >
                  <span :style="`color: ${item.production_accuracy && item.production_accuracy === 100 ? '#388E3C' : item.production_accuracy != null && isJobFinished(item) && item.production_accuracy < 100 ? '#D32F2F' : '#000'};`"><text-highlight :queries="search">{{ item.production_accuracy != null && isJobFinished(item) ? `${item.production_accuracy}%` : '-' }}</text-highlight></span>
                </td>
                <td class="pl-1 pr-1">
                  <a
                    style="white-space: nowrap;"
                    @click="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) ? openPlannedShipDateForm(item) : ''"
                  ><text-highlight :queries="search">{{ item.planned_ship_date_short }}</text-highlight></a>
                </td>
                <td class="pl-0 pr-0">
                  <v-icon
                    v-if="item.ship_date_is_up == 1"
                    color="#388E3C"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-up
                  </v-icon>
                  <v-icon
                    v-else-if="item.ship_date_is_up == 0"
                    color="#D32F2F"
                    style="font-size: 20px;"
                  >
                    mdi-arrow-down
                  </v-icon>
                </td>
                <td
                  class="pl-1 pr-1"
                >
                  <span :style="`color: ${item.windows_accuracy && item.windows_accuracy === 100 ? '#388E3C' : item.windows_accuracy != null && isJobShipped(item) && item.windows_accuracy < 100 ? '#D32F2F' : '#000'};`"><text-highlight :queries="search">{{ item.windows_accuracy != null && isJobShipped(item) ? `${item.windows_accuracy}%` : '-' }}</text-highlight></span>
                </td>
                <td
                  class="pl-1 pr-1"
                >
                  <v-chip
                    v-if="item.delay_reason"
                    small
                    :color="item && item.delay_reason ? item.delay_reason.color : 'black'"
                    text-color="white"
                  >
                    {{ item && item.delay_reason ? item.delay_reason.name : '' }}
                  </v-chip>
                </td>
                <td class="pl-1 pr-1">
                  <v-tooltip
                    v-if="item.last_note"
                    top
                    color="black"
                  >
                    <template #activator="{ on }">
                      <span
                        style="white-space: nowrap; color: rgb(255, 152, 0);"
                        v-on="on"
                      >
                        <v-btn
                          v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdProductionSupervisor) || roles.includes(userRoleIdGlassHandler)"
                          icon
                          small
                          @click="openNotes(item.id)"
                        >
                          <v-icon
                            small
                          >
                            mdi-eye
                          </v-icon>
                        </v-btn>
                        <!-- <text-highlight
                          :queries="search"
                        >{{ item.last_note_short }}</text-highlight> -->
                      </span>
                    </template>
                    <span>{{ item.last_note }}</span>
                  </v-tooltip>
                </td>

                <td
                  id="cellOverflow"
                  :class="(isDarkMode ? 'theme--dark ' : '') + 'pl-0 pr-0 text-end'"
                >
                  <!-- <v-btn
                    v-if="item.status_id == statusIdOnHand"
                    class="ml-1 mt-1 mb-1"
                    color="primary"
                    outlined
                    small
                    @click="openEdit(item)"
                  >
                    EDIT
                  </v-btn>
                  <v-btn
                    v-if="item.status_id == statusIdOnHand"
                    class="ml-1 mt-1 mb-1 mr-1"
                    color="error"
                    outlined
                    small
                    @click="softDelete(item.id)"
                  >
                    DELETE
                  </v-btn> -->
                  <v-btn
                    v-if="item.is_shipping && item.total_shipping == 0 && ((roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate)) && item.is_glaze == 1) && item.status_id === statusIdInProgress"
                    class="ml-1 mr-3 mt-1 mb-1 elevation-0"
                    color="#0BDE79"
                    small
                    @click="toggle(item.id, item.status_id)"
                  >
                    <span style="color: white;">DONE</span>
                  </v-btn>
                  <v-btn
                    v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate)) && item.status_id === statusIdCompleted"
                    class="ml-1 mr-3 mt-1 mb-1 elevation-0"
                    color="#0BDE79"
                    small
                    @click="toggle(item.id, item.status_id)"
                  >
                    <span style="color: white;">RESTORE</span>
                  </v-btn>
                  <v-menu
                    v-if="item.status_id != statusIdOnHand"
                    offset-y
                  >
                    <template #activator="{ on, attrs }">
                      <v-btn
                        class="mt-1 mb-1 mr-1"
                        elevation="0"
                        fab
                        outlined
                        x-small
                        v-bind="attrs"
                        tile
                        color="primary"
                        style="border-radius: 7px; width: 28px !important; height: 28px !important;"
                        v-on="on"
                      >
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list
                      class="pa-3"
                    >
                      <v-list-item
                        v-if="(item.status_id == statusIdInProgress || item.status_id == statusIdOnHand) && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin))"
                        @click="openEdit(item)"
                      >
                        <v-list-item-title style="color: #1976d2; font-weight: 600;">
                          EDIT
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin)) && (item.status_id == statusIdInProgress || item.status_id == statusIdOnHand)"
                        @click="softDelete(item.id)"
                      >
                        <v-list-item-title style="color: #ff5252; font-weight: 600;">
                          DELETE
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdProductionSupervisor) || roles.includes(userRoleIdGlassHandler)"
                        @click="openNotes(item.id)"
                      >
                        <v-list-item-title style="color: #ff9800; font-weight: 600;">
                          NOTES {{ item.notes ? `(${item.notes.length})` : '' }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin)) && (item.status_id == statusIdInProgress || item.status_id == statusIdOnHand)"
                        @click="toggle(item.id, item.status_id, true)"
                      >
                        <v-list-item-title style="color: purple; font-weight: 600;">
                          ARCHIVE
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin)) && (item.status_id == statusIdInProgress || item.status_id == statusIdOnHand)"
                        @click="delay(item)"
                      >
                        <v-list-item-title style="color: #00695C; font-weight: 600;">
                          DELAY
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider />
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate))"
                        @click="openTruckForm(item)"
                      >
                        <v-list-item-title
                          style="color: gray; font-weight: 600;"
                        >
                          <v-icon
                            small
                            class="mr-1 mb-1"
                            color="gray"
                          >
                            fas fa-plus
                          </v-icon> ADD TRUCK
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="((roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate))) && item.truck_schedule_total > 0"
                        @click="redirectTrucks(item.job_id)"
                      >
                        <v-list-item-title
                          style="color: gray; font-weight: 600;"
                        >
                          VIEW TRUCKS {{ `(${item.truck_schedule_total})` }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider />
                      <v-list-item
                        v-if="!item.is_splander_paint && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdSplanderPaintSupervisor))"
                        @click="finishStage(item.id, spandrelId)"
                      >
                        <v-list-item-title style="color: #F7014C; font-weight: bold;">
                          FINISH SPANDREL
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-else-if="item.is_splander_paint && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdSplanderPaintSupervisor))"
                        @click="cancelStage(item.id, spandrelId)"
                      >
                        <v-list-item-title style="color: #F7014C; font-weight: bold;">
                          CANCEL SPANDREL
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="!item.is_panels && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdSplanderPaintSupervisor))"
                        @click="finishStage(item.id, panelsId)"
                      >
                        <v-list-item-title style="color: #1874A7; font-weight: bold;">
                          FINISH PANELS
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-else-if="item.is_panels && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdSplanderPaintSupervisor))"
                        @click="cancelStage(item.id, panelsId)"
                      >
                        <v-list-item-title style="color: #1874A7; font-weight: bold;">
                          CANCEL PANELS
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="!item.is_material_available && item.status_id != statusIdOnHand && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdProductionSupervisor) || roles.includes(userRoleIdGlassHandler))"
                        @click="finishStage(item.id, materialAvailableId)"
                      >
                        <v-list-item-title style="color: #F7A51C; font-weight: bold;">
                          FINISH MATERIAL
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu
                    v-else
                    offset-y
                  >
                    <template #activator="{ on, attrs }">
                      <v-btn
                        class="mt-1 mb-1 mr-1"
                        elevation="0"
                        fab
                        outlined
                        x-small
                        v-bind="attrs"
                        tile
                        color="primary"
                        style="border-radius: 7px; width: 28px !important; height: 28px !important;"
                        v-on="on"
                      >
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list
                      class="pa-3"
                    >
                      <v-list-item
                        v-if="(item.status_id == statusIdInProgress || item.status_id == statusIdOnHand) && (roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin))"
                        @click="openEdit(item)"
                      >
                        <v-list-item-title style="color: #1976d2; font-weight: 600;">
                          EDIT
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdProductionAdmin)) && (item.status_id == statusIdInProgress || item.status_id == statusIdOnHand)"
                        @click="softDelete(item.id)"
                      >
                        <v-list-item-title style="color: #ff5252; font-weight: 600;">
                          DELETE
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <window-breakdown-view
          :filter-location-id="filterLocationId"
          :filter-job-sub-class="filterJobSubClass"
          :filter-job="filterJob"
          :inventory-class-id="inventoryClassId"
          :filter-planned-ship-date="filterPlannedShipDate"
          :filter-planned-ship-date-end="filterPlannedShipDateEnd"
          :filter-production-completion-date="filterProductionCompletionDate"
          :filter-production-completion-date-end="filterProductionCompletionDateEnd"
          :status="status"
          @open-notes="openNotes"
        />
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialogProdBacklogSchedule"
      max-width="300px"
    >
      <v-card v-if="selectedProdBacklogItem">
        <v-card-text class="pt-6">
          <v-text-field
            v-model="selectedProdBacklogItem.production_backlog"
            label="Production Backlog"
            hide-details
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="normal"
            class="mr-2"
            @click="dialogProdBacklogSchedule = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="updateProductionBacklog"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogShipBacklogSchedule"
      max-width="300px"
    >
      <v-card v-if="selectedShipBacklogItem">
        <v-card-text class="pt-6">
          <v-text-field
            v-model="selectedShipBacklogItem.shipping_backlog"
            label="Shipping Backlog"
            hide-details
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="normal"
            class="mr-2"
            @click="dialogShipBacklogSchedule = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="updateShipBacklog"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogSPGlassNote"
      max-width="300px"
    >
      <v-card v-if="selectedItem">
        <v-card-text class="pt-6">
          <v-select
            v-model="selectedItem.sp_note_status_id"
            label="SP PO# Glass Note"
            item-value="id"
            item-text="name"
            :items="noteStatuses"
            clearable
          >
            <template slot="label">
              SU PO# Glass Note
            </template>
          </v-select>
          <v-text-field
            v-if="selectedItem.sp_note_status_id === noteStatusIdShort"
            v-model="selectedItem.sp_note"
            label="SP PO# Missing"
            type="number"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="normal"
            class="mr-2"
            @click="dialogSPGlassNote = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="updateSPGlassNote"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogSUGlassNote"
      max-width="300px"
    >
      <v-card v-if="selectedItem">
        <v-card-text class="pt-6">
          <v-select
            v-model="selectedItem.su_note_status_id"
            label="SU PO# Glass Note"
            item-value="id"
            item-text="name"
            :items="noteStatuses"
            clearable
          >
            <template slot="label">
              SU PO# Glass Note
            </template>
          </v-select>
          <v-text-field
            v-if="selectedItem.su_note_status_id === noteStatusIdShort"
            v-model="selectedItem.su_note"
            label="SU PO# Missing"
            type="number"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="normal"
            class="mr-2"
            @click="dialogSUGlassNote = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="updateSUGlassNote"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogGlassRequiredByDateMultiple"
      max-width="350px"
    >
      <v-card>
        <v-card-title class="business-date-picker-dialog-title">
          Glass Required By Date
        </v-card-title>
        <v-card-text class="pt-6">
          <v-row>
            <v-col>
            <business-date-picker
              v-model="glassRequiredByDateMultiple"
              no-title
              scrollable
              :min="getScheduleDateMinDate(dayAfterFour, selectedItems)"
              @input="onGlassRequiredByDateChange(glassRequiredByDateMultiple, selectedItems)"
            >
              <sealed-unit-overbooking-status-chip
                class="mx-4 mb-2"
                :message="sealedUnitOverbookedErrorMessage"
                :checking="isCheckingSealedUnitCount"
                :overbooked="isSealedUnitOverbooked"
                :checked="isSealedUnitCountChecked"
              />
            </business-date-picker>
            </v-col>
          </v-row>
        </v-card-text>
        <div class="business-date-picker-dialog-action-divider" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogGlassRequiredByDateMultiple = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            :loading="isCheckingSealedUnitCount"
            :disabled="isSealedUnitOverbooked || isCheckingSealedUnitCount"
            @click="updateGlassRequiredByDateMultiple()"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogGlassReqByDate"
      max-width="350px"
    >
      <v-card v-if="selectedItem">
        <v-card-title class="business-date-picker-dialog-title">
          Glass Required By Date
        </v-card-title>
        <v-card-text class="pt-6">
          <v-row>
            <v-col>
              <business-date-picker
                v-model="selectedItem.glass_required_by"
                no-title
                scrollable
                :min="getScheduleDateMinDate(dayAfterFour)"
                @input="onGlassRequiredByDateChange(selectedItem.glass_required_by)"
              >
                <sealed-unit-overbooking-status-chip
                  class="mx-4 mb-2"
                  :message="sealedUnitOverbookedErrorMessage"
                  :checking="isCheckingSealedUnitCount"
                  :overbooked="isSealedUnitOverbooked"
                  :checked="isSealedUnitCountChecked"
                />
              </business-date-picker>
            </v-col>
          </v-row>
        </v-card-text>
        <div class="business-date-picker-dialog-action-divider" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogGlassReqByDate = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            :loading="isCheckingSealedUnitCount"
            :disabled="isSealedUnitOverbooked || isCheckingSealedUnitCount"
            @click="updateGlassRequiredByDate(selectedItem.id, selectedItem.glass_required_by)"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogProductionCompletionDate"
      max-width="350px"
    >
      <v-card v-if="selectedItem">
        <v-card-title class="business-date-picker-dialog-title">
          Production Completion Date
        </v-card-title>
        <v-card-text class="pt-6">
          <v-row>
            <v-col>
              <business-date-picker
                v-model="selectedItem.production_completion_date"
                no-title
                scrollable
                :min="getScheduleDateMinDate(dayAfterSeven)"
                @input="onProductionCompletionDateChange(selectedItem.production_completion_date)"
              >
                <sealed-unit-overbooking-status-chip
                  class="mx-4 mb-2"
                  :message="sealedUnitOverbookedErrorMessage"
                  :checking="isCheckingSealedUnitCount"
                  :overbooked="isSealedUnitOverbooked"
                  :checked="isSealedUnitCountChecked"
                />
              </business-date-picker>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col>
              <v-text-field
                v-model="selectedItem.production_completion_time"
                type="time"
                :rules="[(v) => !!v || 'Production Copmetion Time is required']"
              >
                <template slot="label">
                  Production Copmetion Time<RedAsterisk />
                </template>
              </v-text-field>
            </v-col>
          </v-row> -->
        </v-card-text>
        <div class="business-date-picker-dialog-action-divider" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogProductionCompletionDate = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            :loading="isCheckingSealedUnitCount"
            :disabled="isSealedUnitOverbooked || isCheckingSealedUnitCount"
            @click="updateProductionCompletionDate(selectedItem.id, selectedItem.production_completion_date, selectedItem.production_completion_time)"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogProductionCompletionDateMultiple"
      max-width="350px"
    >
      <v-card>
        <v-card-title class="business-date-picker-dialog-title">
          Production Completion Date
        </v-card-title>
        <v-card-text class="pt-6">
          <v-row>
            <v-col>
              <business-date-picker
                v-model="productionCompletionDateMultiple"
                :min="getScheduleDateMinDate(dayAfterSeven, selectedItems)"
                no-title
                scrollable
                @input="onProductionCompletionDateChange(productionCompletionDateMultiple, selectedItems)"
              >
                <sealed-unit-overbooking-status-chip
                  class="mx-4 mb-2"
                  :message="sealedUnitOverbookedErrorMessage"
                  :checking="isCheckingSealedUnitCount"
                  :overbooked="isSealedUnitOverbooked"
                  :checked="isSealedUnitCountChecked"
                />
              </business-date-picker>
            </v-col>
          </v-row>
          </v-card-text>
        <div class="business-date-picker-dialog-action-divider" />
        <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click="dialogProductionCompletionDateMultiple = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              :loading="isCheckingSealedUnitCount"
              :disabled="isSealedUnitOverbooked || isCheckingSealedUnitCount"
              @click="updateProductionCompletionDateMultiple()"
            >
              Apply
            </v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPlannedDate"
      max-width="350px"
    >
      <v-card v-if="selectedItem">
        <v-card-title class="business-date-picker-dialog-title">
          Planned Ship Date
        </v-card-title>
        <v-card-text class="pt-6">
          <v-row>
            <v-col>
              <business-date-picker
                v-model="selectedItem.planned_ship_date"
                no-title
                scrollable
                :min="getScheduleDateMinDate(getMinDate())"
                @input="onPlannedShipDateChange(selectedItem.planned_ship_date)"
              >
                <sealed-unit-overbooking-status-chip
                  class="mx-4 mb-2"
                  :message="sealedUnitOverbookedErrorMessage"
                  :checking="isCheckingSealedUnitCount"
                  :overbooked="isSealedUnitOverbooked"
                  :checked="isSealedUnitCountChecked"
                />
              </business-date-picker>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col>
              <v-text-field
                v-model="selectedItem.planned_ship_time"
                type="time"
                :rules="[(v) => !!v || 'Ship Time is required']"
              >
                <template slot="label">
                  Ship Time<RedAsterisk />
                </template>
              </v-text-field>
            </v-col>
          </v-row> -->
        </v-card-text>
        <div class="business-date-picker-dialog-action-divider" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogPlannedDate = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            :loading="isCheckingSealedUnitCount"
            :disabled="isSealedUnitOverbooked || isCheckingSealedUnitCount"
            @click="updatePlannedShipDate(selectedItem.id, selectedItem.planned_ship_date, selectedItem.planned_ship_time)"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPlannedShipDateMultiple"
      max-width="500px"
      min-width="500px"
    >
      <v-card style="min-width: 500px;">
        <v-card-title class="business-date-picker-dialog-title">
          Planned Ship Date
        </v-card-title>
        <v-card-text>
          <div class="mb-3">
            Select Job Location to move to Current
          </div>
          <v-form ref="formJob">
            <v-autocomplete
              v-model="selectedLocationId"
              :items="locations"
              item-text="name"
              item-value="id"
              :rules="[(v) => !!v || 'Job Location is required']"
              clearable
              class="mb-3"
            >
              <template slot="label">
                Job Location<RedAsterisk />
              </template>
            </v-autocomplete>
          </v-form>
          <business-date-picker
            v-model="plannedShipDateMultiple"
            no-title
            scrollable
            :min="getScheduleDateMinDate(getMinDate(true), selectedItems)"
            @input="onPlannedShipDateChange(plannedShipDateMultiple, selectedItems)"
            width="100%"
          />
          <sealed-unit-overbooking-status-chip
            class="mx-4 mb-2"
            :message="sealedUnitOverbookedErrorMessage"
            :checking="isCheckingSealedUnitCount"
            :overbooked="isSealedUnitOverbooked"
            :checked="isSealedUnitCountChecked"
          />
        </v-card-text>
        <div class="business-date-picker-dialog-action-divider" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogPlannedShipDateMultiple = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            :loading="isCheckingSealedUnitCount"
            :disabled="isSealedUnitOverbooked || isCheckingSealedUnitCount"
            @click="updatePlannedShipDateMultiple();"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <production-schedule-form
      ref="productionForm"
      @success="get()"
    />
    <production-schedule-note-form
      ref="noteForm"
      @success="get()"
    />
    <production-schedule-history-form
      ref="historyForm"
      @success="get()"
    />

    <truck-schedule-approve-form
      ref="approveForm"
      @success="get()"
    />

    <production-schedule-finished-good-form
      ref="finishedGoodForm"
    />

    <window-breakdown-items-form
      ref="windowBreakdownItemsForm"
    />

    <production-schedule-finished-good-grouped-form
      ref="finishedGoodGroupedForm"
    />

    <bill-of-lading-returned-windows-form
      ref="billOfLadingReturnedWindowsForm"
    />

    <production-schedule-delay-reason-form
      ref="delayReasonForm"
      @success="get()"
    />
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import ProductionScheduleForm from '@/components/forms/productionSchedules/ProductionScheduleForm';
import ProductionScheduleNoteForm from '@/components/forms/productionSchedules/ProductionScheduleNoteForm';
import ProductionScheduleHistoryForm from '@/components/forms/productionSchedules/ProductionScheduleHistoryForm';
import TruckScheduleApproveForm from '@/components/forms/truckSchedules/TruckScheduleApproveForm';
import WindowBreakdownView from '@/views/ProductionSchedules/WindowBreakdownView';
import ProductionScheduleFinishedGoodForm from '@/components/forms/productionSchedules/ProductionScheduleFinishedGoodForm';
import * as FormatHelpers from '@/helpers/FormatHelpers';
import { saveAs } from 'file-saver';
import WindowBreakdownItemsForm from '@/components/forms/productionSchedules/WindowBreakdownItemsForm';
import ProductionScheduleFinishedGoodGroupedForm from '@/components/forms/productionSchedules/ProductionScheduleFinishedGoodGroupedForm';
import BillOfLadingReturnedWindowsForm from '@/components/forms/billOfLadings/BillOfLadingReturnedWindowsForm.vue';
import ProductionScheduleDelayReasonForm from '@/components/forms/productionSchedules/ProductionScheduleDelayReasonForm.vue';
import { addBusinessDays, subtractBusinessDays } from '@/helpers/BusinessDateHelper';
import BusinessDatePicker from '@/components/elements/BusinessDatePicker.vue';
import SealedUnitOverbookingStatusChip from '@/components/elements/SealedUnitOverbookingStatusChip.vue';

export default {
  components: {
    BusinessDatePicker,
    ProductionScheduleForm,
    ProductionScheduleNoteForm,
    ProductionScheduleHistoryForm,
    TruckScheduleApproveForm,
    WindowBreakdownView,
    ProductionScheduleFinishedGoodForm,
    WindowBreakdownItemsForm,
    ProductionScheduleFinishedGoodGroupedForm,
    BillOfLadingReturnedWindowsForm,
    ProductionScheduleDelayReasonForm,
    SealedUnitOverbookingStatusChip,
  },
  props: {

  },
  data: () => ({
    items: [],
    totalItems: 0,
    allItems: [],
    loading: false,
    filterJob: null,
    filterPo: null,
    filterStage: null,
    filterGlassReqBy: null,
    filterPlannedShipDate: null,
    filterPlannedShipDateEnd: null,
    filterProductionCompletionDate: null,
    filterProductionCompletionDateEnd: null,
    filterLocationId: null,
    filterJobSubClass: null,
    filterRecordType: null,
    dateMenu: false,
    inventoryClassId: [],
    jobs: [],
    poNumbers: [],
    stages: [{ name: 'Material', id: 1, code: 'M' }, { name: 'Cut', id: 2, code: 'C' }, { name: 'Assembled', id: 3, code: 'A' }, { name: 'Spandrel', id: 4, code: 'S' }, { name: 'Panels', id: 5, code: 'P' }, { name: 'T&B', id: 6, code: 'T' }, { name: 'Glazed', id: 7, code: 'G' }],
    footer: {
      'items-per-page-options': [20, 50, 100, 500, 1000],
    },
    statusIdInProgress: 1,
    statusIdCompleted: 2,
    statusIdOnHand: 3,
    noteStatusIdOk: 1,
    noteStatusIdShort: 2,
    noteStatusIdZero: 3,
    materialAvailableId: 1,
    cutId: 2,
    assembleId: 3,
    spandrelId: 4,
    panelsId: 5,
    tAndBId: 6,
    glazedId: 7,
    ppStartedId: 8,
    ppFinishedId: 9,
    topSpaceHeight: 300,
    windowHeight: 1000,
    windowWidth: 1000,
    status: null,
    pagination: {
      itemsPerPage: 500,
      page: 1,
    },
    sort: {
      order_by_first: 'production_completion_date',
      direction_sort: true,
    },
    filterMenu: false,
    dateMenuRequiredBy: false,
    dateMenuShipDate: false,
    dateMenuShipDateEnd: false,
    dateMenuProductionCompletionDate: false,
    dateMenuProductionCompletionDateEnd: false,
    roles: [],
    locations: [],
    userRoleIdAdmin: 3,
    userRoleIdAssociate: 6,
    userRoleIdGlassHandler: 13,
    userRoleIdProductionSupervisor: 18,
    userRoleIdSplanderPaintSupervisor: 21,
    userRoleIdProductionAdmin: 22,
    finishedGoodStatusIdQuarantined: 13,
    recordTypes: [{ id: 1, name: 'Default Records' }, { id: 2, name: 'Manual Records' }],
    selectedItems: [],
    tabs: [],
    locationTabFilter: null,
    selectedTab: null,
    selectedProdBacklogItem: null,
    dialogProdBacklogSchedule: false,
    dialogShipBacklogSchedule: false,
    selectedShipBacklogItem: null,
    dialogSPGlassNote: false,
    dialogSUGlassNote: false,
    dialogGlassReqByDate: false,
    dialogPlannedDate: false,
    dialogProductionCompletionDate: false,
    selectedItem: null,
    noteStatuses: [],
    isShowStages: true,
    isShowBreakdown: false,
    typeIdSUItems: 1,
    typeIdSPItems: 2,
    loadingJobs: false,
    loadingPo: false,
    dialogGlassRequiredByDateMultiple: false,
    dialogPlannedShipDateMultiple: false,
    dialogProductionCompletionDateMultiple: false,
    productionCompletionDateMultiple: null,
    glassRequiredByDateMultiple: null,
    plannedShipDateMultiple: null,
    isGlassRelated: false,
    windowAccuracy: null,
    today: new Date().toISOString().substr(0, 10),
    selectedLocationId: null,
    isCheckingSealedUnitCount: false,
    isSealedUnitOverbooked: false,
    isSealedUnitCountChecked: false,
    sealedUnitOverbookedDate: null,
    maximumSealedUnitsAllowedPerDay: 300,
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
      user: (state) => state.user,
      isDarkMode: 'isDarkMode',
      productionScheduleState: (state) => state.productionScheduleState,
      holidaysDateToNameMap: (state) => state.holidaysDateToNameMap,
    }),
    ...mapGetters([
      'businessRulesGetBoolean',
    ]),
    dayAfterTomorrow() {
      return addBusinessDays(this.today, 2, this.holidaysDateToNameMap);
    },
    dayAfterFour() {
      return addBusinessDays(this.today, 4, this.holidaysDateToNameMap);
    },
    dayAfterSeven() {
      return addBusinessDays(this.today, 7, this.holidaysDateToNameMap);
    },
    dayAfterEight() {
      return addBusinessDays(this.today, 8, this.holidaysDateToNameMap);
    },
    headers() {
      const headers = [];
      if (this.roles.includes(this.userRoleIdAdmin) || this.roles.includes(this.userRoleIdProductionAdmin) || this.roles.includes(this.userRoleIdAssociate)) {
        headers.push({
          text: '', fullText: '', value: 'checkbox', class: 'pl-1 pr-1', width: '2%', sortable: false,
        });
      }
      headers.push({
        text: 'Class', fullText: 'Class', value: 'class', class: 'pl-1 pr-1', width: '2%',
      });
      headers.push({
        text: 'Loc.', fullText: 'Location', value: 'location', class: 'pl-1 pr-1', width: '3%',
      });
      headers.push({
        text: 'Project', fullText: 'Project', value: 'project', class: 'pl-1 pr-1',
      });
      headers.push({
        text: 'Floor', fullText: 'Floor', value: 'project_floor', class: 'pl-1 pr-1',
      });
      headers.push({
        text: 'WO#', fullText: 'WO#', value: 'wo_number', class: 'pl-1 pr-1', width: '2%',
      });
      if (this.isShowStages) {
        headers.push({
          text: 'Win. Vert.', fullText: 'Window Verticals', value: 'window_verticals', class: 'pl-1 pr-1', width: '2%', sortable: false,
        });
        headers.push({
          text: 'Pat. D.', fullText: 'Patio Doors', value: 'patio_doors', class: 'pl-1 pr-1', width: '2%', sortable: false,
        });
        headers.push({
          text: 'Eu. D.', fullText: 'Euro Doors', value: 'euro_doors', class: 'pl-1 pr-1', width: '2%', sortable: false,
        });
        headers.push({
          text: 'Total Rel. Qty', fullText: 'Total Release Quantity', value: 'total_release_qty', class: 'pl-1 pr-1', width: '2%', sortable: false,
        });
        headers.push({
          text: 'PP', fullText: 'Projected Panels', value: 'projected-panels', class: 'pl-1 pr-1', width: '2%', sortable: false,
        });
        headers.push({
          text: 'Spa.', fullText: 'Spandrel Paint?', value: 'is_splander_paint', class: 'pl-1 pr-1', width: '2%', sortable: false,
        });
        headers.push({
          text: 'Pan.', fullText: 'Panels?', value: 'is_panels', class: 'pl-1 pr-1', width: '2%', sortable: false,
        });
        headers.push({
          text: 'Mat. Av.', fullText: 'Material Available?', value: 'is_material_available', class: 'pl-1 pr-1', width: '2%', sortable: false,
        });
        headers.push({
          text: 'Cut', fullText: 'Cut?', value: 'is_cut', class: 'pl-1 pr-1', width: '2%', sortable: false,
        });
        headers.push({
          text: 'As.', fullText: 'Assembled?', value: 'is_assemble', class: 'pl-1 pr-1', width: '2%', sortable: false,
        });
        headers.push({
          text: 'T&B', fullText: 'Tape and Bracket?', value: 'is_t_and_b', class: 'pl-1 pr-1', width: '2%', sortable: false,
        });
        headers.push({
          text: 'Glaz.', fullText: 'Glazed?', value: 'is_glaze', class: 'pl-1 pr-1', width: '2%', sortable: false,
        });
      }

      headers.push({
        text: 'Prod. Back', fullText: 'Production Backlog', value: 'production_backlog', class: 'pl-1 pr-1', width: '3%', sortable: false,
      });
      headers.push({
        text: 'Ship. Back', fullText: 'Shipping Backlog', value: 'shipping_backlog', class: 'pl-1 pr-1', width: '2%', sortable: false,
      });
      headers.push({
        text: 'Rec. Back', fullText: 'Received Backlog', value: 'received_backlog', class: 'pl-1 pr-1', width: '2%', sortable: false,
      });
      headers.push({
        text: 'Ret. Back', fullText: 'Returned Backlog', value: 'returned_backlog', class: 'pl-1 pr-1', width: '2%', sortable: false,
      });
      headers.push({
        text: 'Quar.', fullText: 'Quarantined', value: 'quarantined', class: 'pl-1 pr-1', width: '2%', sortable: false,
      });
      headers.push({
        text: 'SP PO#', fullText: 'SP PO#', value: 'sp_po_number', class: 'pl-1 pr-1', width: '2%',
      });
      headers.push({
        text: 'Gl. Note', fullText: 'Glass Notes', value: 'sp_note', class: 'pl-1 pr-1', width: '3%', sortable: false,
      });
      if (!this.isShowStages) {
        headers.push({
          text: 'Status', fullText: 'Status', value: 'sp_po_status', class: 'pl-1 pr-1', width: '5%', sortable: false, align: 'center',
        });
      }
      headers.push({
        text: 'S/U PO#', fullText: 'S/U PO#', value: 'su_po_number', class: 'pl-1 pr-1', width: '2%',
      });
      headers.push({
        text: 'Gl. Note', fullText: 'Glass Notes', value: 'su_note', class: 'pl-1 pr-1', width: '3%', sortable: false,
      });
      if (!this.isShowStages) {
        headers.push({
          text: 'Status', fullText: 'Status', value: 'su_po_status', class: 'pl-1 pr-1', width: '5%', sortable: false, align: 'center',
        });
      }
      headers.push({
        text: 'Glass Req. By', fullText: 'Glass Required By', value: 'glass_required_by', class: 'pl-1 pr-1', width: '2%',
      });
      headers.push({
        text: '', fullText: '', value: 'arrow_required_by', class: 'pl-0 pr-0', width: '1%', sortable: false,
      });
      headers.push({
        text: 'Prod. Comp. Date', fullText: 'Production Completion Date', value: 'production_completion_date', class: 'pl-1 pr-0', width: '2%',
      });
      headers.push({
        text: '', fullText: '', value: 'arrow', class: 'pl-0 pr-0', width: '1%', sortable: false,
      });
      headers.push({
        text: 'Prod. Acc.', fullText: 'Production Accuracy - Average percentage of finished goods produced ahead of the planned ship date', value: 'windows_accuracy', class: 'pl-1 pr-1', width: '2%',
      });
      headers.push({
        text: 'Plan. Ship Date', fullText: 'Planned Shi Date', value: 'planned_ship_date', class: 'pl-1 pr-0', width: '2%',
      });
      headers.push({
        text: '', fullText: '', value: 'arrow', class: 'pl-0 pr-0', width: '1%', sortable: false,
      });
      headers.push({
        text: 'Ship. Acc.', fullText: 'Shipping Accuracy - Average percentage of finished goods shipped ahead of the planned ship date', value: 'shipping_accuracy', class: 'pl-1 pr-1', width: '2%',
      });
      headers.push({
        text: 'Delay Reason', fullText: 'Delay Reason', value: 'delay_reason', class: 'pl-1 pr-1', width: '5%', sortable: false, align: 'center',
      });
      headers.push({
        text: 'Note', fullText: 'Note', value: 'last_note', class: 'pl-1 pr-1', width: '5%', sortable: false,
      });
      headers.push({
        text: '', value: 'actions', align: 'end', class: 'pl-0 pr-0', sortable: false,
      });
      return headers;
    },
    sealedUnitOverbookedErrorMessage() {
      if (this.isCheckingSealedUnitCount) return 'Checking Sealed Units...';
      const overbookedDate = this.sealedUnitOverbookedDate
        ? moment(this.sealedUnitOverbookedDate, 'YYYY-MM-DD').format('MMM D, YYYY')
        : 'this date';
      if (this.isSealedUnitOverbooked) {
        return `Sealed Units overbooked for ${overbookedDate}`;
      }
      if (this.isSealedUnitCountChecked) {
        return 'Sealed Unit capacity OK';
      }
      return null;
    },
  },
  watch: {
    inventoryClassId() {
      this.get();
      this.getWindowAccuracy();
    },
    filterJob(value) {
      this.storeState('job_id', value);
      this.get();
    },
    filterPo(value) {
      this.storeState('po_number', value);
      this.get();
    },
    filterStage(value) {
      this.storeState('stage', value);
      this.get();
    },
    filterGlassReqBy(value) {
      this.storeState('glass_required_by', value);
      this.get();
    },
    filterPlannedShipDate(value) {
      this.storeState('planned_ship_date', value);
      this.get();
    },
    filterPlannedShipDateEnd(value) {
      this.storeState('planned_ship_date_end', value);
      this.get();
    },
    filterProductionCompletionDate(value) {
      this.storeState('production_completion_date', value);
      this.get();
    },
    filterProductionCompletionDateEnd(value) {
      this.storeState('production_completion_date_end', value);
      this.get();
    },
    filterLocationId() {
      this.get();
    },
    filterRecordType(value) {
      this.storeState('record_type', value);
      this.get();
    },
    filterJobSubClass() {
      this.get();
    },
    status() {
      this.get();
    },
    pagination() {
      this.get();
    },
    $route(to) {
      this.status = to.params.status;
      // if (this.status === this.statusIdOnHand) {
      //   this.pagination.sortBy = ['po_number'];
      // } else {
      //   this.pagination.sortBy = ['planned_ship_date'];
      // }
    },
    search() {
      this.get();
    },
    locationTabFilter() {
      if (this.locationTabFilter === 0) {
        this.filterLocationId = null;
        this.get();
        return;
      }
      const location = this.tabLocations[this.locationTabFilter];
      if (!location) return;
      this.filterLocationId = location.id;
      this.get();
    },
    isShowBreakdown(value) {
      this.storeState('isShowBreakdown', value);
    },
    isShowStages(value) {
      this.storeState('isShowStages', value);
    },
    isGlassRelated(value) {
      this.storeState('isGlassRelated', value);
      this.get();
    },
  },
  created() {
    this.status = this.$route.params.status;
    if (!this.status) return;
    if (this.productionScheduleState) {
      if (this.productionScheduleState.pagination) { this.pagination = this.productionScheduleState.pagination; }
      if (this.productionScheduleState.job_id) { this.filterJob = this.productionScheduleState.job_id; }
      if (this.productionScheduleState.po_number) { this.filterPo = this.productionScheduleState.po_number; }
      if (this.productionScheduleState.stage) { this.filterStage = this.productionScheduleState.stage; }
      if (this.productionScheduleState.glass_required_by) { this.filterGlassReqBy = this.productionScheduleState.glass_required_by; }
      if (this.productionScheduleState.planned_ship_date) { this.filterPlannedShipDate = this.productionScheduleState.planned_ship_date; }
      if (this.productionScheduleState.planned_ship_date_end) { this.filterPlannedShipDateEnd = this.productionScheduleState.planned_ship_date_end; }
      if (this.productionScheduleState.production_completion_date) { this.filterProductionCompletionDate = this.productionScheduleState.production_completion_date; }
      if (this.productionScheduleState.production_completion_date_end) { this.filterProductionCompletionDateEnd = this.productionScheduleState.production_completion_date_end; }
      if (this.productionScheduleState.record_type) { this.filterRecordType = this.productionScheduleState.record_type; }
      if (this.productionScheduleState.selectedTab) { this.tabChange(this.productionScheduleState.selectedTab); }
      if (this.productionScheduleState.isShowBreakdown !== null) { this.isShowBreakdown = this.productionScheduleState.isShowBreakdown; }
      if (this.productionScheduleState.isShowStages !== null) { this.isShowStages = this.productionScheduleState.isShowStages; }
      if (this.productionScheduleState.isGlassRelated !== null) { this.isGlassRelated = this.productionScheduleState.isGlassRelated; }
    }
    this.roles = this.user.roles.map((x) => x.id);
    this.windowHeight = window.innerHeight - this.topSpaceHeight;
    this.windowWidth = window.innerWidth;
    this.getLocations();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
    const tableWrapper = document.querySelector('.v-data-table__wrapper');
    tableWrapper.addEventListener('scroll', this.checkScroll);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    const tableWrapper = document.querySelector('.v-data-table__wrapper');
    tableWrapper.removeEventListener('scroll', this.checkScroll);
  },
  methods: {
    init() {
      this.getJobs();
      this.getGlassPos();
      this.getNoteStatuses();
      this.$store.dispatch('getHolidays');
    },

    getMinimumPlannedShipDateFromProductionCompletionDate(productionCompletionDate) {
      return addBusinessDays(productionCompletionDate, 1, this.holidaysDateToNameMap);
    },

    getScheduleDateMinDate(minDate, items = [this.selectedItem]) {
      const itemsToCheck = Array.isArray(items) ? items : [items];
      const isDateUnrestricted = itemsToCheck.length > 0 && itemsToCheck.every((item) => item
        && parseInt(item.sp_note_status_id, 10) === this.noteStatusIdOk
        && parseInt(item.su_note_status_id, 10) === this.noteStatusIdOk);
      return isDateUnrestricted ? null : minDate;
    },

    shouldUpdatePlannedShipDate(currentPlannedShipDate, minimumPlannedShipDate) {
      if (!currentPlannedShipDate) return true;
      return currentPlannedShipDate < minimumPlannedShipDate;
    },

    storeState(property, value) {
      const state = this.productionScheduleState;
      state[property] = value;
      this.$store.commit('storeProductionScheduleState', state);
    },

    async get() {
      if (this.inventoryClassId === null) return;
      this.loading = true;
      this.items = [];
      this.totalItems = 0;
      const submitModel = {
        filters: {
          status_id: this.status,
          inventory_class_id: this.inventoryClassId,
          stage: this.filterStage,
          job_id: this.filterJob,
          date: this.filterDate,
          po_number: this.filterPo,
          glass_required_by: this.filterGlassReqBy,
          start_date: this.filterPlannedShipDate,
          end_date: this.filterPlannedShipDateEnd,
          start_date_production_completion: this.filterProductionCompletionDate,
          end_date_production_completion: this.filterProductionCompletionDateEnd,
          location_id: this.filterLocationId,
          record_type: this.filterRecordType,
          job_sub_class_id: this.filterJobSubClass,
          is_glass_related: this.isGlassRelated === true ? 1 : 0,
        },
        pagination: this.pagination,
        search: this.search,
        sort: this.sort,
      };
      const res = await this.$api.productionSchedule.readData(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      this.loading = false;
      this.init();
      if (!res || !res.data || res.data.length === 0) {
        this.items = [];
        this.allItems = [];
        this.totalItems = 0;
        return;
      }
      this.selectedItems = [];
      this.allItems = res.data;
      this.items = res.data.slice(0, 100);
      this.totalItems = res.total;
    },

    async getJobs() {
      this.loadingJobs = true;
      const submitModel = {
        filters: { inventory_class_ids: this.inventoryClassId, is_manual: 0 },
      };
      const res = await this.$api.job.readDDL(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) {
        this.loadingJobs = false;
        return;
      }
      this.jobs = res;
      this.loadingJobs = false;
    },

    async getGlassPos() {
      this.loadingPo = true;
      this.poNumbers = [];
      const submitModel = {
        filters: { 
          inventory_class_ids: this.inventoryClassId,
          job_code: null,
        },
      };
      const res = await this.$api.glass.read(submitModel, null, 'read/po-numbers');
      if (!res) {
        this.poNumbers = [];
        this.loadingPo = false;
        return;
      }
      this.poNumbers.push('N/A');
      this.poNumbers.push(...res);
      this.loadingPo = false;
    },

    async getLocations() {
      this.locations = await this.$api.location.getList();

      const locationId99Vinyl = 3;
      const locationId141Adesso = 8;
      this.locations = this.locations.filter((x) => x.id === locationId99Vinyl || x.id === locationId141Adesso);
      this.tabs.push(...this.locations);
      this.tabs.forEach((x) => {
        // eslint-disable-next-line no-param-reassign
        x.type = 'location';
      });
      this.tabs.push({
        id: 2, name: 'CORNER POST', color: '#E53935', type: 'sub-class',
      }, {
        id: 3, name: 'EURO DOOR', color: '#FDD835', type: 'sub-class',
      });
    },

    async getNoteStatuses() {
      this.noteStatuses = await this.$api.productionScheduleNoteStatus.get();
    },

    async getWindowAccuracy() {
      const submitModel = {
        inventory_class_id: this.inventoryClassId,
        location_id: this.filterLocationId,
        job_sub_class_id: this.filterJobSubClass,
      };
      this.windowAccuracy = await this.$api.productionSchedule.store(submitModel, 'window-accuracy');
    },

    openFinishedGoodForm(item, statusId) {
      if (!this.roles.includes(this.userRoleIdAdmin) && !this.roles.includes(this.userRoleIdProductionAdmin) && !this.roles.includes(this.userRoleIdAssociate) && !this.roles.includes(this.userRoleIdSplanderPaintSupervisor) && !this.roles.includes(this.userRoleIdProductionSupervisor)) return;
      this.$refs.finishedGoodForm.open(item, statusId);
    },

    triggerStageChange(item, status) {
      if (!this.roles.includes(this.userRoleIdAdmin) && !this.roles.includes(this.userRoleIdProductionAdmin) && !this.roles.includes(this.userRoleIdAssociate) && !this.roles.includes(this.userRoleIdSplanderPaintSupervisor) && !this.roles.includes(this.userRoleIdProductionSupervisor)) return;

      if (status === this.materialAvailableId) {
        if (item.is_material_available) {
          this.cancelStage(item.id, this.materialAvailableId);
        } else {
          this.finishStage(item.id, this.materialAvailableId);
        }
      } else if (status === this.cutId) {
        if (item.is_cut) {
          this.cancelStage(item.id, this.cutId);
        } else {
          this.finishStage(item.id, this.cutId);
        }
      } else if (status === this.assembleId) {
        if (item.is_assemble) {
          this.cancelStage(item.id, this.assembleId);
        } else {
          this.finishStage(item.id, this.assembleId);
        }
      } else if (status === this.spandrelId) {
        if (item.is_splander_paint) {
          this.cancelStage(item.id, this.spandrelId);
        } else {
          this.finishStage(item.id, this.spandrelId);
        }
      } else if (status === this.panelsId) {
        if (item.is_panels) {
          this.cancelStage(item.id, this.panelsId);
        } else {
          this.finishStage(item.id, this.panelsId);
        }
      } else if (status === this.tAndBId) {
        if (item.is_t_and_b) {
          this.cancelStage(item.id, this.tAndBId);
        } else {
          this.finishStage(item.id, this.tAndBId);
        }
      } else if (status === this.ppStartedId) {
        if (item.is_pp_started) {
          this.finishStage(item.id, this.ppFinishedId);
        } else {
          this.finishStage(item.id, this.ppStartedId);
        }
      }
    },

    async finishStage(itemId, status) {
      let title = '';

      switch (status) {
        case this.materialAvailableId:
          title = 'Are you sure that you want to FINISH MATERIAL AVAILABLE?';
          break;
        case this.cutId:
          title = 'Are you sure that you want to FINISH CUTTING?';
          break;
        case this.assembleId:
          title = 'Are you sure that you want to FINISH ASSEMBLING?';
          break;
        case this.spandrelId:
          title = 'Are you sure that you want to FINISH SPANDREL PAINT?';
          break;
        case this.panelsId:
          title = 'Are you sure that you want to FINISH PANELS?';
          break;
        case this.tAndBId:
          title = 'Are you sure that you want to FINISH T & B?';
          break;
        case this.ppStartedId:
          title = 'Are you sure that you want to START PROJECTED PANELS production?';
          break;
        case this.ppFinishedId:
          title = 'Are you sure that you want to FINISH PROJECTED PANELS production?';
          break;
        default:
          break;
      }
      const confirm = await this.$refs.confirmForm.open({
        title,
      });
      if (!confirm) return;
      const submitModel = {
        id: itemId,
        status,
      };
      const res = await this.$api.productionSchedule.store(submitModel, 'stage');
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.toggleStageUpdate(itemId, status);
    },

    async cancelStage(itemId, status) {
      let title = '';

      switch (status) {
        case this.materialAvailableId:
          title = 'Are you sure that you want to CANCEL MATERIAL AVAILABLE?';
          break;
        case this.cutId:
          title = 'Are you sure that you want to CANCEL CUTTING?';
          break;
        case this.assembleId:
          title = 'Are you sure that you want to CANCEL ASSEMBLING?';
          break;
        case this.spandrelId:
          title = 'Are you sure that you want to CANCEL SPANDREL PAINT?';
          break;
        case this.panelsId:
          title = 'Are you sure that you want to CANCEL PANELS?';
          break;
        case this.tAndBId:
          title = 'Are you sure that you want to CANCEL T & B?';
          break;
        case this.glazedId:
          title = 'Are you sure that you want to CANCEL GLAZE?';
          break;
        case this.ppStartedId:
          title = 'Are you sure that you want to CANCEL PROJECTED PANELS production?';
          break;
        case this.ppFinishedId:
          title = 'Are you sure that you want to CANCEL PROJECTED PANELS production?';
          break;
        default:
          break;
      }
      const confirm = await this.$refs.confirmForm.open({
        title,
      });
      if (!confirm) return;
      const submitModel = {
        id: itemId,
        status,
      };
      const res = await this.$api.productionSchedule.store(submitModel, 'cancel-stage');
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.toggleStageUpdate(itemId, status);
    },

    async toggleStageUpdate(itemId, status) {
      const index = this.items.findIndex((x) => x.id === itemId);
      if (index === -1) return;
      switch (status) {
        case this.materialAvailableId:
          this.items[index].is_material_available = !this.items[index].is_material_available;
          break;
        case this.cutId:
          this.items[index].is_cut = !this.items[index].is_cut;
          break;
        case this.assembleId:
          this.items[index].is_assemble = !this.items[index].is_assemble;
          break;
        case this.spandrelId:
          this.items[index].is_splander_paint = !this.items[index].is_splander_paint;
          break;
        case this.panelsId:
          this.items[index].is_panels = !this.items[index].is_panels;
          break;
        case this.tAndBId:
          this.items[index].is_t_and_b = !this.items[index].is_t_and_b;
          break;
        case this.glazedId:
          this.items[index].is_glaze = !this.items[index].is_glaze;
          break;
        case this.ppStartedId:
          this.items[index].is_pp_started = !this.items[index].is_pp_started;
          break;
        case this.ppFinishedId:
          this.items[index].is_pp_finished = !this.items[index].is_pp_finished;
          break;
        default:
          break;
      }
      this.$set(this.items, index, this.items[index]);
    },

    async toggle(id, statusId, isAchive = false) {
      let title = '';
      if (isAchive) {
        title = 'ARCHIVE';
      } else if (statusId === this.statusIdInProgress) {
        title = 'COMPLETE';
      } else {
        title = 'RESTORE';
      }
      const confirm = await this.$refs.confirmForm.open({
        title: `Are you sure that you want to ${title} this record?`,
      });
      if (!confirm) return;
      const res = await this.$api.productionSchedule.get(`toggle/${id}/${statusId}`);
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    open() {
      this.$refs.productionForm.open();
    },

    openManual() {
      this.$refs.manualForm.open();
    },

    openEdit(item) {
      this.$refs.productionForm.open(item.id);
    },

    openNotes(id) {
      this.$refs.noteForm.open(id);
    },

    openHistory(id) {
      this.$refs.historyForm.open(id);
    },

    async softDelete(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      this.$bus.$emit('loading');
      const res = await this.$api.productionSchedule.delete(id);
      this.$bus.$emit('loading');
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    onResize() {
      this.windowHeight = window.innerHeight - this.topSpaceHeight;
      this.windowWidth = window.innerWidth;
    },

    clearAllFilters() {
      this.filterJob = null;
      this.filterPo = null;
      this.filterStage = null;
      this.filterGlassReqBy = null;
      this.filterPlannedShipDate = null;
      this.filterPlannedShipDateEnd = null;
      this.filterLocationId = null;
      this.filterRecordType = null;
      this.filterProductionCompletionDate = null;
      this.filterProductionCompletionDateEnd = null;
    },

    async runWebhook(documentType) {
      if (this.inventoryClassId === null) {
        this.$bus.$emit('showError', 'Please select an inventory class');
        return;
      }
      this.$bus.$emit('loading');
      const MODULE_PRODUCTION_SCHEDULE_ID = 20;
      let status = 'Current';
      if (this.status === 2) {
        status = 'Archived';
      }
      const submitModel = {
        status,
        inventory_class_id: this.inventoryClassId,
        module_id: MODULE_PRODUCTION_SCHEDULE_ID,
        location_id: this.filterLocationId ? this.filterLocationId : 0,
        sub_class: this.filterJobSubClass ? this.filterJobSubClass : 0,
        is_show_stages: this.isShowStages === true ? 'Yes' : 'No',
        is_show_glass_related: this.isGlassRelated === true ? 'Yes' : 'No',
      };
      const res = await this.$api.webhook.store(submitModel, 'run');
      if (!res) return;
      const pdf = await this.$api.report.download(res.id, documentType);
      if (!pdf) {
        this.$bus.$emit('showError', 'Report Failed');
        return;
      }
      const now = FormatHelpers.getFileTimestamp();
      const fileName = `Report_${res.report_title}_${now}`;
      const file = new Blob([pdf], {
        type: documentType === 'pdf' ? 'application/pdf' : 'application/vnd.ms-excel',
      });
      if (documentType === 'pdf') {
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
      saveAs(file, fileName);
      this.$bus.$emit('loading');
    },

    openGlassRequiredByDateForm(item) {
      this.resetSealedUnitOverbookedValidation();
      this.selectedItem = item;
      this.dialogGlassReqByDate = true;
    },

    openGlassRequiredByDateFormMultiple() {
      this.resetSealedUnitOverbookedValidation();
      this.glassRequiredByDateMultiple = null;
      this.dialogGlassRequiredByDateMultiple = true;
    },

    async updateGlassRequiredByDate(id, glassRequiredByDate) {
      const isValidSealedUnitDate = await this.validateSealedUnitCountForDate(glassRequiredByDate, [this.selectedItem], { silent: true });
      if (!isValidSealedUnitDate) return false;

      this.$bus.$emit('loading');
      try {
        const res = await this.$api.productionSchedule.update({ id, glass_required_by: glassRequiredByDate }, 'glass-required-by-date');
        if (!res) return false;

        const dateProduction = addBusinessDays(glassRequiredByDate, 3, this.holidaysDateToNameMap);

        const resProd = await this.$api.productionSchedule.update({ id, production_completion_date: dateProduction, production_completion_time: '07:00' }, 'production-completion-date');
        if (!resProd) return false;

        const minimumPlannedShipDate = this.getMinimumPlannedShipDateFromProductionCompletionDate(dateProduction);
        if (this.shouldUpdatePlannedShipDate(this.selectedItem.planned_ship_date, minimumPlannedShipDate)) {
          const resPlannedShipDate = await this.$api.productionSchedule.update(
            { id, planned_ship_date: minimumPlannedShipDate, planned_ship_time: this.selectedItem.planned_ship_time },
            'planned-ship-date',
          );
          if (!resPlannedShipDate) return false;
        }

        this.$bus.$emit('showSuccess');
        this.dialogGlassReqByDate = false;
        this.get();
        return true;
      } finally {
        this.$bus.$emit('loading');
      }
    },

    async updateGlassRequiredByDateMultiple() {
      const glassRequiredByDates = this.selectedItems.map(() => this.glassRequiredByDateMultiple);
      const isValidSealedUnitDate = await this.validateSealedUnitCountsForMultipleDates(glassRequiredByDates, this.selectedItems, { silent: true });
      if (!isValidSealedUnitDate) return;

      this.$bus.$emit('loading');
      try {
        const items = [];
        this.selectedItems.forEach((x) => {
          items.push(this.$api.productionSchedule.update({ id: x.id, glass_required_by: this.glassRequiredByDateMultiple }, 'glass-required-by-date'));
        });
        const itemsRes = await Promise.all(items);
        if (itemsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }

        const dateProduction = addBusinessDays(this.glassRequiredByDateMultiple, 3, this.holidaysDateToNameMap);

        const productions = [];
        this.selectedItems.forEach((x) => {
          productions.push(this.$api.productionSchedule.update({ id: x.id, production_completion_date: dateProduction, production_completion_time: '07:00' }, 'production-completion-date'));
        });

        const productionsRes = await Promise.all(productions);

        if (productionsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }

        const minimumPlannedShipDate = this.getMinimumPlannedShipDateFromProductionCompletionDate(dateProduction);
        const plannedShipDateItems = [];
        this.selectedItems.forEach((x) => {
          if (this.shouldUpdatePlannedShipDate(x.planned_ship_date, minimumPlannedShipDate)) {
            plannedShipDateItems.push(
              this.$api.productionSchedule.update(
                { id: x.id, planned_ship_date: minimumPlannedShipDate, planned_ship_time: x.planned_ship_time },
                'planned-ship-date',
              ),
            );
          }
        });

        const plannedShipDateItemsRes = await Promise.all(plannedShipDateItems);

        if (plannedShipDateItemsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }

        this.$bus.$emit('showSuccess');
        this.dialogGlassRequiredByDateMultiple = false;
        this.get();
      } finally {
        this.$bus.$emit('loading');
      }
    },

    openPlannedShipDateForm(item) {
      this.resetSealedUnitOverbookedValidation();
      this.selectedItem = item;
      this.dialogPlannedDate = true;
    },

    openPlannedShipDateMultipleForm() {
      this.resetSealedUnitOverbookedValidation();
      this.plannedShipDateMultiple = null;
      this.dialogPlannedShipDateMultiple = true;
    },

    async updatePlannedShipDate(id, plannedShipDate, plannedShipTime) {
      const glassRequiredByDate = subtractBusinessDays(plannedShipDate, 4, this.holidaysDateToNameMap);
      const isValidSealedUnitDate = await this.validateSealedUnitCountForDate(glassRequiredByDate, [this.selectedItem], { silent: true });
      if (!isValidSealedUnitDate) return;

      this.$bus.$emit('loading');
      try {
        const res = await this.$api.productionSchedule.update({ id, planned_ship_date: plannedShipDate, planned_ship_time: plannedShipTime }, 'planned-ship-date');
        if (!res) {
          this.$bus.$emit('showError');
          return;
        }

        // eslint-disable-next-line eqeqeq
        if (this.status == this.statusIdOnHand) {
          const date = subtractBusinessDays(plannedShipDate, 1, this.holidaysDateToNameMap);

          const resProd = await this.$api.productionSchedule.update(
            { id, production_completion_date: date },
            'production-completion-date',
          );

          if (!resProd) {
            this.$bus.$emit('showError');
            return;
          }

          const resGlass = await this.$api.productionSchedule.update(
            { id, glass_required_by: glassRequiredByDate },
            'glass-required-by-date',
          );

          if (!resGlass) {
            this.$bus.$emit('showError');
            return;
          }
        }

        this.$bus.$emit('showSuccess');
        this.dialogPlannedDate = false;
        this.get();
      } finally {
        this.$bus.$emit('loading');
      }
    },

    async updatePlannedShipDateMultiple() {
      const valid = await this.$refs.formJob.validate();
      if (!valid) return;

      const glassRequiredByDate = subtractBusinessDays(this.plannedShipDateMultiple, 4, this.holidaysDateToNameMap);
      const glassRequiredByDates = this.selectedItems.map(() => glassRequiredByDate);
      const isValidSealedUnitDate = await this.validateSealedUnitCountsForMultipleDates(glassRequiredByDates, this.selectedItems, { silent: true });
      if (!isValidSealedUnitDate) return;

      this.$bus.$emit('loading');
      try {
        const items = [];
        this.selectedItems.forEach((x) => {
          items.push(this.$api.productionSchedule.update({ id: x.id, planned_ship_date: this.plannedShipDateMultiple, location_id: this.selectedLocationId }, 'planned-ship-date'));
        });
        const itemsRes = await Promise.all(items);
        if (itemsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }

        // eslint-disable-next-line eqeqeq
        if (this.status == this.statusIdOnHand) {
          const dateProduction = subtractBusinessDays(this.plannedShipDateMultiple, 1, this.holidaysDateToNameMap);

          const productions = [];
          this.selectedItems.forEach((x) => {
            productions.push(
              this.$api.productionSchedule.update(
                { id: x.id, production_completion_date: dateProduction },
                'production-completion-date',
              ),
            );
          });

          const productionsRes = await Promise.all(productions);

          if (productionsRes.includes(false)) {
            this.$bus.$emit('showError');
            return;
          }

          const glassItems = [];
          this.selectedItems.forEach((x) => {
            glassItems.push(
              this.$api.productionSchedule.update(
                { id: x.id, glass_required_by: glassRequiredByDate },
                'glass-required-by-date',
              ),
            );
          });

          const glassItemsRes = await Promise.all(glassItems);

          if (glassItemsRes.includes(false)) {
            this.$bus.$emit('showError');
            return;
          }
        }

        this.$bus.$emit('showSuccess');
        this.dialogPlannedShipDateMultiple = false;
        this.get();
      } finally {
        this.$bus.$emit('loading');
      }
    },

    openProductionCompletionDateForm(item) {
      this.resetSealedUnitOverbookedValidation();
      this.selectedItem = item;
      this.dialogProductionCompletionDate = true;
    },

    openProductionCompletionDateMultipleForm() {
      this.resetSealedUnitOverbookedValidation();
      this.productionCompletionDateMultiple = null;
      this.dialogProductionCompletionDateMultiple = true;
    },

    async updateProductionCompletionDate(id, productionCompletionDate, productionCompletionTime) {
      const glassRequiredByDate = subtractBusinessDays(productionCompletionDate, 3, this.holidaysDateToNameMap);
      const isValidSealedUnitDate = await this.validateSealedUnitCountForDate(glassRequiredByDate, [this.selectedItem], { silent: true });
      if (!isValidSealedUnitDate) return;

      this.$bus.$emit('loading');
      try {
        const res = await this.$api.productionSchedule.update({ id, production_completion_date: productionCompletionDate, production_completion_time: productionCompletionTime }, 'production-completion-date');
        if (!res) return;
        const resGlass = await this.$api.productionSchedule.update({ id, glass_required_by: glassRequiredByDate }, 'glass-required-by-date');
        if (!resGlass) return;

        const minimumPlannedShipDate = this.getMinimumPlannedShipDateFromProductionCompletionDate(productionCompletionDate);
        if (this.shouldUpdatePlannedShipDate(this.selectedItem.planned_ship_date, minimumPlannedShipDate)) {
          const resPlannedShipDate = await this.$api.productionSchedule.update(
            { id, planned_ship_date: minimumPlannedShipDate, planned_ship_time: this.selectedItem.planned_ship_time },
            'planned-ship-date',
          );
          if (!resPlannedShipDate) {
            this.$bus.$emit('showError');
            return;
          }
        }

        this.$bus.$emit('showSuccess');
        this.dialogProductionCompletionDate = false;
        this.get();
      } finally {
        this.$bus.$emit('loading');
      }
    },

    async updateProductionCompletionDateMultiple() {
      const glassRequiredByDate = subtractBusinessDays(this.productionCompletionDateMultiple, 3, this.holidaysDateToNameMap);
      const glassRequiredByDates = this.selectedItems.map(() => glassRequiredByDate);
      const isValidSealedUnitDate = await this.validateSealedUnitCountsForMultipleDates(glassRequiredByDates, this.selectedItems, { silent: true });
      if (!isValidSealedUnitDate) return;

      this.$bus.$emit('loading');
      try {
        const items = [];
        this.selectedItems.forEach((x) => {
          items.push(this.$api.productionSchedule.update({ id: x.id, production_completion_date: this.productionCompletionDateMultiple }, 'production-completion-date'));
        });
        const itemsRes = await Promise.all(items);
        if (itemsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }

        const glassItems = [];
        this.selectedItems.forEach((x) => {
          glassItems.push(this.$api.productionSchedule.update({ id: x.id, glass_required_by: glassRequiredByDate }, 'glass-required-by-date'));
        });

        const glassItemsRes = await Promise.all(glassItems);

        if (glassItemsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }

        const minimumPlannedShipDate = this.getMinimumPlannedShipDateFromProductionCompletionDate(this.productionCompletionDateMultiple);
        const plannedShipDateItems = [];
        this.selectedItems.forEach((x) => {
          if (this.shouldUpdatePlannedShipDate(x.planned_ship_date, minimumPlannedShipDate)) {
            plannedShipDateItems.push(
              this.$api.productionSchedule.update(
                { id: x.id, planned_ship_date: minimumPlannedShipDate, planned_ship_time: x.planned_ship_time },
                'planned-ship-date',
              ),
            );
          }
        });

        const plannedShipDateItemsRes = await Promise.all(plannedShipDateItems);

        if (plannedShipDateItemsRes.includes(false)) {
          this.$bus.$emit('showError');
          return;
        }

        this.$bus.$emit('showSuccess');
        this.dialogProductionCompletionDateMultiple = false;
        this.get();
      } finally {
        this.$bus.$emit('loading');
      }
    },

    async updateProductionBacklog() {
      if (!this.selectedProdBacklogItem) return;
      this.selectedProdBacklogItem.production_backlog = this.selectedProdBacklogItem.production_backlog || this.selectedProdBacklogItem.production_backlog === 0 ? this.selectedProdBacklogItem.production_backlog : null;
      const res = await this.$api.productionSchedule.update({ id: this.selectedProdBacklogItem.id, production_backlog: this.selectedProdBacklogItem.production_backlog }, 'production-backlog');
      if (!res) return;
      this.get();
      this.dialogProdBacklogSchedule = false;
    },

    async updateShipBacklog() {
      if (!this.selectedShipBacklogItem) return;
      this.selectedShipBacklogItem.shipping_backlog = this.selectedShipBacklogItem.shipping_backlog || this.selectedShipBacklogItem.shipping_backlog === 0 ? this.selectedShipBacklogItem.shipping_backlog : null;
      const res = await this.$api.productionSchedule.update({ id: this.selectedShipBacklogItem.id, shipping_backlog: this.selectedShipBacklogItem.shipping_backlog }, 'shipping-backlog');
      if (!res) return;
      this.get();
      this.dialogShipBacklogSchedule = false;
    },

    async updateSPGlassNote() {
      if (!this.selectedItem) return;
      if (this.selectedItem.sp_note_status_id !== this.noteStatusIdShort) {
        this.selectedItem.sp_note = null;
      }
      const res = await this.$api.productionSchedule.update({ id: this.selectedItem.id, sp_note_status_id: this.selectedItem.sp_note_status_id, sp_note: this.selectedItem.sp_note }, 'sp-glass-note');
      if (!res) return;
      const index = this.items.findIndex((x) => x.id === this.selectedItem.id);
      if (index === -1) return;
      this.items[index].sp_note = this.selectedItem.sp_note;
      this.items[index].sp_note_status_id = this.selectedItem.sp_note_status_id;
      const spNote = this.noteStatuses.find((x) => x.id === this.selectedItem.sp_note_status_id);
      this.items[index].sp_note_status = spNote;
      this.$set(this.items, index, this.items[index]);
      this.dialogSPGlassNote = false;
    },

    async updateSUGlassNote() {
      if (!this.selectedItem) return;
      if (this.selectedItem.su_note_status_id !== this.noteStatusIdShort) {
        this.selectedItem.su_note = null;
      }
      const res = await this.$api.productionSchedule.update({ id: this.selectedItem.id, su_note_status_id: this.selectedItem.su_note_status_id, su_note: this.selectedItem.su_note }, 'su-glass-note');
      if (!res) return;
      const index = this.items.findIndex((x) => x.id === this.selectedItem.id);
      if (index === -1) return;
      this.items[index].su_note = this.selectedItem.su_note;
      this.items[index].su_note_status_id = this.selectedItem.su_note_status_id;
      const suNote = this.noteStatuses.find((x) => x.id === this.selectedItem.su_note_status_id);
      this.items[index].su_note_status = suNote;
      this.$set(this.items, index, this.items[index]);
      this.dialogSUGlassNote = false;
    },

    openTruckForm(item) {
      this.$refs.approveForm.openProductionSchedule(item);
    },

    subtractWeekdaysMoment(ymd, days) {
      let m = moment(ymd, 'YYYY-MM-DD'); // parse as local date
      let remaining = days;

      while (remaining > 0) {
        m = m.subtract(1, 'day');
        const day = m.day(); // 0=Sunday … 6=Saturday
        if (day !== 0 && day !== 6) remaining--;
      }
      return m.format('YYYY-MM-DD');
    },

    addWeekdaysMoment(ymd, days) {
      let m = moment(ymd, 'YYYY-MM-DD'); // parse as local date
      let remaining = days;

      while (remaining > 0) {
        m = m.add(1, 'day');
        const day = m.day(); // 0 = Sunday … 6 = Saturday
        if (day !== 0 && day !== 6) remaining--;
      }
      return m.format('YYYY-MM-DD');
    },

    async archiveAll() {
      const confirm = await this.$refs.confirmForm.open({
        // eslint-disable-next-line eqeqeq
        title: `Are you sure that you want to ${this.status == 1 ? 'ARCHIVE' : 'RESTORE'} all selected records?`,
      });
      if (!confirm) return;
      const requests = [];
      this.selectedItems.forEach((x) => {
        requests.push(this.$api.productionSchedule.get(`toggle/${x.id}/${x.status_id}`));
      });

      const res = await Promise.all(requests);
      if (res.includes(false)) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    tabChange(item) {
      if (this.selectedTab === item) {
        this.selectedTab = null;
        this.filterJobSubClass = null;
        this.filterLocationId = null;
        this.get();
        this.getWindowAccuracy();
        this.storeState('selectedTab', null);
        return;
      }
      this.selectedTab = item;
      if (item.type === 'sub-class') {
        this.filterJobSubClass = item.id;
        this.filterLocationId = null;
      } else if (item.type === 'location') {
        this.filterLocationId = item.id;
        // const jobSubClass4800Windows = 1;
        // const tab300Chrislea = 2;
        // if (item.id === tab300Chrislea) {
        //   this.filterJobSubClass = jobSubClass4800Windows;
        // } else { this.filterJobSubClass = null; }
      }
      this.storeState('selectedTab', item);
      this.get();
      this.getWindowAccuracy();
    },

    openMenuProdBacklog(id) {
      const index = this.items.findIndex((item) => item.id === id);
      if (index === -1) return;
      this.selectedProdBacklogItem = this.items[index];
      this.dialogProdBacklogSchedule = true;
    },

    openMenuSPGlassNote(id) {
      const index = this.items.findIndex((item) => item.id === id);
      if (index === -1) return;
      this.selectedItem = this.items[index];
      this.dialogSPGlassNote = true;
    },
    openMenuSUGlassNote(id) {
      const index = this.items.findIndex((item) => item.id === id);
      if (index === -1) return;
      this.selectedItem = this.items[index];
      this.dialogSUGlassNote = true;
    },

    openMenuShipBacklog(id) {
      const index = this.items.findIndex((item) => item.id === id);
      if (index === -1) return;
      this.selectedShipBacklogItem = this.items[index];
      this.dialogShipBacklogSchedule = true;
    },

    redirectTrucks(jobId) {
      this.$router.push({ name: 'TruckScheduleRequestView', params: { jobIdProp: jobId } });
    },

    openFinishedGoods() {
      this.$refs.finishedGoodGroupedForm.open();
    },

    openQuarantinedWindows() {
      this.$refs.finishedGoodGroupedForm.open({
        title: 'Quarantined Windows',
        statusId: this.finishedGoodStatusIdQuarantined,
      });
    },

    async sendEmailPdf() {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to send an email containing the latest Production Schedule reports?',
      });
      if (!confirm) return;
      this.$bus.$emit('loading');
      const res = await this.$api.productionSchedule.get('send-email-pdf');
      this.$bus.$emit('loading');
      if (res) {
        this.$bus.$emit('showSuccess');
      } else {
        this.$bus.$emit('showError');
      }
    },

    openWindowBreakdown(item, typeId) {
      const data = {
        work_order: item.wo_number,
        project_name: item.project,
        reference: item.project_floor,
      };
      this.$refs.windowBreakdownItemsForm.open(data, typeId);
    },

    checkScroll(event) {
      const bottomOfTable = (event.target.scrollHeight < event.target.scrollTop + event.target.clientHeight + 5 && event.target.scrollHeight > event.target.scrollTop + event.target.clientHeight - 5) || event.target.scrollHeight === event.target.scrollTop + event.target.clientHeight;
      if (bottomOfTable) {
        this.items = this.allItems.slice(0, this.items.length + 100);
      }
    },

    openReturnedWindows() {
      this.$refs.billOfLadingReturnedWindowsForm.open();
    },

    isJobFinished(item) {
      if (item.is_shipping === 1) {
        return true;
      }
      return false;
    },

    isJobShipped(item) {
      if (item.is_received === 1) {
        return true;
      }
      return false;
    },

    formatLocation(location) {
      const [num, word] = location.trim().split(' ');
      return `${num} ${word.slice(0, 2)}`;
    },

    delay(item) {
      this.$refs.delayReasonForm.open(item);
    },

    updateOptions(newOptions) {
      this.pagination = newOptions;
      this.sort = {
        order_by_first: newOptions.sortBy[0],
        direction_sort: newOptions.sortDesc[0],
      };
      this.storeState('pagination', newOptions);
    },

    getMinDate(multiple = false) {
      let item = null;

      if (multiple) {
        if (!this.selectedItems || this.selectedItems.length !== 1) return this.dayAfterEight;
        // eslint-disable-next-line prefer-destructuring
        item = this.selectedItems[0];
      } else {
        if (!this.selectedItem) return this.dayAfterEight;
        item = this.selectedItem;
      }

      if (!item.job) return this.dayAfterEight;
      const subclassIdCornerPost = 2;
      if (item.job.sub_class_id === subclassIdCornerPost || item.job.reference.includes('BS')) {
        return this.today;
      }
      return this.dayAfterEight;
    },

    getUniqueDates(dates) {
      return [...new Set(dates.filter((date) => !!date))];
    },

    getSealedUnitOverbookingPoNumber(items = [this.selectedItem]) {
      const itemsToCheck = Array.isArray(items) ? items : [items];
      const itemWithSuPoNumber = itemsToCheck.find((item) => item
        && parseInt(item.status_id, 10) !== this.statusIdCompleted
        && item.su_po_number);
      return itemWithSuPoNumber ? itemWithSuPoNumber.su_po_number : null;
    },

    resetSealedUnitOverbookedValidation() {
      this.isSealedUnitOverbooked = false;
      this.isCheckingSealedUnitCount = false;
      this.isSealedUnitCountChecked = false;
      this.sealedUnitOverbookedDate = null;
    },

    async validateSealedUnitCountForDate(date, items = [this.selectedItem], options = {}) {
      const { silent = false } = options;
      if (!silent) this.resetSealedUnitOverbookedValidation();
      if (!date || !this.businessRulesGetBoolean('Sealed Unit Overbooking Check')) return true;

      const sealedUnitOverbookingPoNumber = this.getSealedUnitOverbookingPoNumber(items);

      if (!silent) {
        this.isCheckingSealedUnitCount = true;
        this.isSealedUnitCountChecked = false;
        this.sealedUnitOverbookedDate = date;
      }

      try {
        const overbookingCheck = await this.$api.glass.store({
          glass_required_by: date,
          po_number: sealedUnitOverbookingPoNumber || null,
        }, 'sealed-unit-overbooking-check');

        if (!silent && this.sealedUnitOverbookedDate !== date) return true;

        if (!overbookingCheck || overbookingCheck.status === 'error') {
          this.$bus.$emit('showError', overbookingCheck && overbookingCheck.message ? overbookingCheck.message : 'Unable to check sealed unit count. Please try again.');
          return false;
        }

        this.maximumSealedUnitsAllowedPerDay = overbookingCheck.maximum_sealed_units_allowed_per_day || this.maximumSealedUnitsAllowedPerDay;
        if (silent && overbookingCheck.is_overbooked) {
          this.sealedUnitOverbookedDate = date;
          this.isSealedUnitOverbooked = true;
          this.isSealedUnitCountChecked = true;
        }
        if (silent) return !overbookingCheck.is_overbooked;

        this.isSealedUnitOverbooked = overbookingCheck.is_overbooked;
        this.isSealedUnitCountChecked = true;
        return !this.isSealedUnitOverbooked;
      } finally {
        if (!silent && this.sealedUnitOverbookedDate === date) {
          this.isCheckingSealedUnitCount = false;
        }
      }
    },

    async validateSealedUnitCountsForMultipleDates(dates, items = [this.selectedItem], options = {}) {
      const uniqueDates = this.getUniqueDates(dates);
      const itemsToCheck = Array.isArray(items) ? items : [items];
      if (!uniqueDates.length) {
        if (!options.silent) this.resetSealedUnitOverbookedValidation();
        return true;
      }

      for (let i = 0; i < uniqueDates.length; i += 1) {
        const date = uniqueDates[i];
        const itemsForDate = itemsToCheck.filter((item, index) => dates[index] === date);
        // eslint-disable-next-line no-await-in-loop
        const isValidSealedUnitDate = await this.validateSealedUnitCountForDate(date, itemsForDate.length ? itemsForDate : itemsToCheck, options);
        if (!isValidSealedUnitDate) return false;
      }

      return true;
    },

    onGlassRequiredByDateChange(date, items = [this.selectedItem]) {
      const itemsToCheck = Array.isArray(items) ? items : [items];
      const dates = itemsToCheck.map(() => date);
      this.validateSealedUnitCountsForMultipleDates(dates, itemsToCheck);
    },

    onProductionCompletionDateChange(productionCompletionDate, items = [this.selectedItem]) {
      if (!productionCompletionDate) {
        this.resetSealedUnitOverbookedValidation();
        return;
      }

      const glassRequiredByDate = subtractBusinessDays(productionCompletionDate, 3, this.holidaysDateToNameMap);
      const itemsToCheck = Array.isArray(items) ? items : [items];
      const dates = itemsToCheck.map(() => glassRequiredByDate);
      this.validateSealedUnitCountsForMultipleDates(dates, itemsToCheck);
    },

    onPlannedShipDateChange(plannedShipDate, items = [this.selectedItem]) {
      if (!plannedShipDate) {
        this.resetSealedUnitOverbookedValidation();
        return;
      }

      const glassRequiredByDate = subtractBusinessDays(plannedShipDate, 4, this.holidaysDateToNameMap);
      const itemsToCheck = Array.isArray(items) ? items : [items];
      const dates = itemsToCheck.map(() => glassRequiredByDate);
      this.validateSealedUnitCountsForMultipleDates(dates, itemsToCheck);
    },
  },
};
</script>

<style scoped>

.business-date-picker-dialog-title {
  background-color: #323232;
  color: #FFFFFF;
}

.business-date-picker-dialog-action-divider {
  width: calc(100% - 48px);
  margin: 0 auto;
  border-top: 1px solid #E0E0E0;
}

#cellOverflow {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  min-width: 120px  !important;
  border-left: 1px solid #E0E0E0;
  background-color: #FAFAFA;

}

#cellOverflow.theme--dark {
  background-color: #323232;
}

span
{
  font-size: 12px !important;
}
::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  background-color: #323232;
}

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th > span {
  color: #FFFFFF;
}

::v-deep .theme--light.v-divider {
    border-color: rgba(0,0,0,0.4) !important;
    border: 1px solid rgba(0,0,0,0.4) !important;
}

:v-deep .v-btn__content
{
  color: white !important;
}

.box
{
  border-radius: 4px;
   width: 25px;
    height: 25px;
}

.empty-box
{
  border: 1.5px solid #FFD84D;
  background-color: #FFFFFF;
}

.red-box
{
  border: 1.5px solid #F44336;
  background-color: #F44336;
}

.yellow-box
{
  border: 1.5px solid #FFD84D;
  background-color: #FFD84D;
}

.green-box
{
  border: 1.5px solid #4CAF50;
  background-color: #4CAF50;
}

.options-item-div
{
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
